import { Locale } from './config'

export const messages = {
  en: {
    common: {
      loading: 'Loading...',
      settings: 'Settings',
      profile: 'Profile',
      profileSettings: 'Profile Settings',
      signOut: 'Sign Out',
      play: 'Play',
      openOnYouTube: 'Open on YouTube',
      userMenu: 'User menu',
      language: 'Language',
      switchTheme: 'Toggle theme',
      themeUseDark: 'Use dark theme',
      themeUseLight: 'Use light theme',
      themeUseSystem: 'Use system theme',
      english: 'English',
      german: 'German',
      back: 'Go back',
      noParentPage: 'No parent page',
      refresh: 'Refresh',
      refreshed: 'Updated',
      loadingEllipsis: 'Loading…',
      // Date/time picker
      time: 'Time',
      clear: 'Clear',
      apply: 'Apply',
      selectTime: 'Select time',
      done: 'Done',
      // Error boundary
      errorTitle: 'Something went wrong',
      errorMessage: 'An unexpected error occurred',
      tryAgain: 'Try again',
      // Day names
      dayMonday: 'Monday',
      dayTuesday: 'Tuesday',
      dayWednesday: 'Wednesday',
      dayThursday: 'Thursday',
      dayFriday: 'Friday',
      daySaturday: 'Saturday',
      daySunday: 'Sunday',
      // Common actions
      save: 'Save',
      cancel: 'Cancel',
      edit: 'Edit',
      copy: 'Copy',
      copied: 'Copied!',
      saving: 'Saving...',
      unknownError: 'Unknown error',
      anErrorOccurred: 'An error occurred',
    },
    auth: {
      signInTitle: 'Sign in to your account',
      signIn: 'Sign In',
      signingIn: 'Signing in...',
      email: 'Email',
      password: 'Password',
      forgotPassword: 'Forgot Password?',
      forgotPasswordTitle: 'Reset your password',
      forgotPasswordHint: "Enter your email address and we'll send you a link to reset your password.",
      sendResetLink: 'Send Reset Link',
      sending: 'Sending...',
      backToSignIn: 'Back to Sign In',
      resetEmailSentTitle: 'Check your email',
      resetEmailSentText: "We've sent a password reset link to",
      resetEmailSentHint: 'Click the link in the email to reset your password. The link will expire in 1 hour.',
      signUpTitle: 'Create your account',
      signUp: 'Sign Up',
      creatingAccount: 'Creating account...',
      noAccount: "Don't have an account?",
      haveAccount: 'Already have an account?',
      signUpLink: 'Sign up',
      signInLink: 'Sign in',
      checkEmail: 'Check your email',
      emailConfirmationText: "We've sent you a confirmation link to",
      emailConfirmationHint: 'Please check your inbox to complete the sign up process.',
      returnToSignIn: 'Return to Sign In',
      resetPasswordTitle: 'Set new password',
      resetPasswordHint: 'Enter your new password below.',
      newPassword: 'New Password',
      confirmPassword: 'Confirm Password',
      updatePassword: 'Update Password',
      updating: 'Updating...',
      passwordMismatch: 'Passwords do not match',
      passwordMinLength: 'Password must be at least 6 characters long',
      resetLinkExpired: 'Password reset link has expired. Please request a new one.',
      resetSuccess: 'Password reset successful! Please sign in with your new password.',
      genericError: 'An error occurred. Please try again.',
      unexpectedError: 'An unexpected error occurred',
      emailRequiredError: 'Email is required',
      resetSendFailed: 'Failed to send reset email',
      createPasswordPlaceholder: 'Create a password',
      enterPasswordPlaceholder: 'Enter your password',
      enterNewPasswordPlaceholder: 'Enter your new password',
      confirmNewPasswordPlaceholder: 'Confirm your new password',
      passwordRule: 'Must be at least 6 characters',
    },
    landing: {
      ctaPrimary: 'View Full Ecosystem Package',
      ctaSecondary: 'See the door',
      ctaContact: 'Contact HumanByte',
      ctaExisting: 'Existing Client? Open Dashboard',
      navSignUp: 'Sign up',
      navLogin: 'Log in',
      navOpenDashboard: 'Open dashboard',
      navLabel: 'Site navigation',
      navOpenMenu: 'Open menu',
      navCloseMenu: 'Close menu',
      chapterRailLabel: 'Chapters',
      trust1: 'Swiss law baseline',
      trust2: 'Cloud + edge resilience',
      trust3: 'Audit-ready event logs',
      consoleRegion: 'Locations',
      consoleDescription: 'Demonstration of the operator console. This is not the live dashboard.',
      consoleUnlock: 'Unlock',
      consoleUnlockHint: 'Click to unlock the door',
      consoleUnlocking: 'Unlocking…',
      consoleOpen: 'Open',
      consoleGranted: 'GRANTED',
      consoleDenied: 'DENIED',
      consoleOperator: 'Operator',
      consoleRemoteReason: 'Remote unlock',
      consoleQrEntry: 'QR entry',
      consoleOutsideHours: 'Outside hours',
      phoneRegion: 'ByteKey',
      phoneDescription: 'Demonstration of the customer QR screen. This is not the live app.',
      phoneTitle: 'QR Entrance',
      phoneHold: 'Click the code',
      phoneScanning: 'Scanning…',
      phoneGranted: 'Entry granted',
      phoneScanTitle: 'How to scan',
      phoneScanText: 'Click the code. The door reads it. The operator sees the pass.',
      phoneTabQr: 'QR CODE',
      phoneTabAbout: 'ABOUT US',
      doorScanner: 'Door scanner',
      bytekeyProduct: 'ByteKey product page',
      storyKicker: 'Two products. One pass.',
      storyTitle: 'A code. A door. A log.',
      beatKey: 'The key',
      beatDoor: 'The door',
      beatOperator: 'The operator',
      recapKey:
        'ByteKey is the iOS and Android app customers use to register, verify their identity, and receive a QR entry credential. Membership becomes a code they already have in their pocket. App Store and Google Play — coming soon.',
      recapDoor:
        'ByteGate is edge hardware plus cloud. A scanner at each door makes the local decision, even offline. The cloud holds the dashboard, device health, and Sentinel morning review.',
      recapOperator:
        'Every pass lands in Locations. Unlock from here. The same window the operator uses all day.',
    },
    nav: {
      docs: 'Docs',
      home: 'Dashboard home',
      primary: 'Primary',
      tabLocations: 'Locations',
      tabLogs: 'Logs',
      tabCustomers: 'Customers',
      tabSentinel: 'Sentinel',
      tabMore: 'More',
      moreHome: 'Dashboard home',
      closeMore: 'Close menu',
    },
    legal: {
      privacy: 'Privacy Policy',
      terms: 'Terms of Service',
    },
    dashboard: {
      title: 'Dashboard',
      subtitle: 'Jump in below, or use the tabs at the bottom of the screen.',
      locations: 'Locations',
      locationsDesc: 'View and manage all locations',
      addNewLocation: 'Add new location',
      addNew: 'Add New',
      accessLogs: 'Access Logs',
      accessLogsDesc: 'View access log history',
      sentinel: 'Sentinel',
      sentinelDesc: 'Daily monitoring and investigation workflow',
      customers: 'Customers',
      customersDesc: 'Search customers, see their details and export newsletter lists',
    },
    customers: {
      title: 'Customers',
      subtitle: 'Bytekey customers of this organization, synced every few minutes.',
      search: 'Search',
      filters: 'Filters',
      searchPlaceholder: 'Search name, email, phone, city or ID',
      loading: 'Loading…',
      updating: 'Updating customers from Bytekey…',
      filterStatus: 'Status',
      statusAll: 'All statuses',
      status_verified: 'Verified',
      status_unverified: 'Not verified',
      status_needs_recovery: 'Needs recovery',
      status_disabled: 'Disabled',
      status_rejected: 'Rejected',
      filterNewsletter: 'Newsletter',
      newsletterAll: 'All',
      newsletterYes: 'Subscribed',
      newsletterNo: 'Not subscribed',
      registeredFrom: 'Registered from',
      registeredTo: 'Registered until',
      sort: 'Sort',
      sortName: 'Name',
      sortNewest: 'Newest first',
      colName: 'Name',
      colContact: 'Contact',
      colCity: 'City',
      colStatus: 'Status',
      colNewsletter: 'Newsletter',
      colRegistered: 'Registered',
      total: '{n} customers',
      empty: 'No customers match these filters.',
      emptyNoData: 'No customers synced yet. Use “Sync now” to load them from Bytekey.',
      notLinked: 'This organization is not linked to a Bytekey app yet, so no customers can be shown.',
      loadFailed: 'Customers could not be loaded.',
      export: 'Export CSV',
      exportExcel: 'Export for Excel',
      exportHint: 'Exports all customers matching the current filters.',
      sync: 'Sync now',
      syncing: 'Syncing…',
      syncFailed: 'Sync failed. Try again in a minute.',
      lastSynced: 'Last synced {time}',
      neverSynced: 'Not synced yet',
      previous: 'Previous',
      next: 'Next',
      pageInfo: '{from}–{to} of {total}',
      back: 'All customers',
      profile: 'Profile',
      firstName: 'First name',
      lastName: 'Last name',
      email: 'Email',
      telephone: 'Phone',
      address: 'Address',
      heardAboutUs: 'Heard about us',
      newsletter: 'Newsletter',
      status: 'Status',
      registeredAt: 'Registered',
      phoneVerifiedAt: 'Phone verified',
      pendingDeletionAt: 'Deletion requested',
      customerId: 'Customer ID',
      yes: 'Yes',
      no: 'No',
      none: '—',
      access: 'Access',
      blocked: 'Blocked',
      blockedSince: 'Blocked since {time}',
      notBlocked: 'Not blocked',
      whitelisted: 'Whitelisted',
      notWhitelisted: 'Not whitelisted',
      block: 'Block at all locations',
      whitelist: 'Whitelist at all locations',
      reasonPrompt: 'Reason (optional)',
      actionDone: 'Saved.',
      actionForbidden: 'Your role cannot do this.',
      actionFailed: 'The change could not be saved.',
      manageInSettings: 'Manage blocks and whitelist in Settings',
      recentVisits: 'Recent visits',
      noVisits: 'No visits recorded at your locations.',
      visitTime: 'Time',
      visitLocation: 'Location',
      visitResult: 'Result',
      viewAllLogs: 'All access logs for this customer',
      notFound: 'Customer not found in this organization.',
      bytekeyWhitelisted: 'Whitelisted in Bytekey',
    },
    storesList: {
      devices: '{n} devices',
      devicesOne: '1 device',
      online: '{n} online',
      offline: '{n} offline',
      updateAvailable: '{n} update available',
      updateAvailablePlural: '{n} updates available',
      allUpToDate: 'All up to date',
      statusOnline: 'Online',
      statusOffline: 'Offline',
      statusProvisioning: 'Provisioning',
      statusError: 'Error',
      lastSeen: 'Last: {time}',
      justNow: 'Just now',
      minutesAgo: '{n}m ago',
      hoursAgo: '{n}h ago',
      daysAgo: '{n}d ago',
      never: 'Never',
      ntpUnsynced: 'NTP unsynced',
      empty: 'No stores found. Get started by creating your first store.',
      cpu: 'CPU',
      mem: 'Mem',
    },
    storeDetail: {
      restart: {
        checking: "Checking restart status…",
        stateUnavailable: "Restart status is unavailable. Check the status before trying again.",
        refresh: "Check restart status",
        checkAgain: "The device has not reported a final outcome yet. Check the status again before taking another action.",
        inProgress: "Restart is in progress. Waiting for the device to acknowledge it.",
        acknowledged: "Device acknowledged the restart. It may take a moment to reconnect.",
        completed: "The device reported that the restart completed.",
        commandFailed: "The restart could not be completed. Check the device connection before trying again after the cooldown.",
        cancelled: "The restart was cancelled. Check the device connection before trying again after the cooldown.",
        button: "Restart device",
        confirm: "Restart the device at {name}? Access control may be briefly interrupted.",
        pending: "Requesting restart…",
        cooldown: "A restart was requested recently. Try again in {seconds} seconds.",
        cooldownUnknown: "A restart was requested recently. Please wait before trying again.",
        forbidden: "You are not authorized to restart this device.",
        failed: "Unable to request a restart. Please try again.",
        requested: "Restart requested. The device may take a moment to reconnect.",
      },

      tabsAria: 'Store tabs',
      tabOverview: 'Overview',
      tabLogs: 'Access Logs',
      tabConfig: 'Configuration',
      tabMaintenance: 'Maintenance',
      copyStoreId: 'Copy store ID',
      storeIdCopied: 'Store ID copied',
      configStatus: 'Config Status:',
      configSynced: 'Config Synced',
      updatePending: 'Update Pending',
      syncRequirement: '(Edge software v{version}+ required for sync status)',
      edgeSoftware: 'Edge Software:',
      unknown: 'Unknown',
      systemHealth: 'System Health',
      todaysTraffic: "Today's Traffic",
      totalAttempts: 'Total Attempts',
      granted: 'Granted',
      denied: 'Denied',
      uniqueCustomers: 'Unique Customers',
      recentEvents: 'Recent Events',
      noRecentEvents: 'No recent events',
      noRecentEventsDesc: 'No recent events. Events will appear here after access attempts.',
      eventAccessAt: 'User {customer} access {result} at {time}',
      deviceSettings: 'Device Settings',
      deviceSetup: 'Device Setup',
      accessLogsDesc: 'Click a log row to expand and view full details.',
      deniedOnly: 'Denied Only',
      colTime: 'Time',
      colCustomerId: 'Customer ID',
      colCustomer: 'Customer',
      colResult: 'Result',
      colIssueType: 'Issue Type',
      rawJson: 'Raw JSON',
      noAccessLogs: 'No access logs found.',
      noDeniedAccessLogs: 'No denied access logs found.',
      notAvailable: 'N/A',
      resultGranted: 'Granted',
      resultDenied: 'Denied',
      resultError: 'Error',
      cpuUsage: 'CPU Usage',
      memoryUsage: 'Memory Usage',
      diskUsage: 'Disk Usage',
      ntpStatus: 'NTP Status',
      ntpSynced: 'Synced',
      ntpUnsynced: 'Unsynced',
      lastCheck: 'Last check:',
      heartbeatInterval: 'Heartbeat Interval (seconds)',
      unlockDuration: 'Unlock Duration (seconds)',
      savePush: 'Save & Push to Device',
      saving: 'Saving…',
      saveSuccess: 'Configuration saved and pushed to device.',
      saveFailed: 'Failed to save configuration.',
      invalidHeartbeat: 'Heartbeat interval must be at least 30 seconds.',
      invalidUnlock: 'Unlock duration must be a positive number.',
      heartbeatHint: 'Minimum 30 seconds. Devices send a heartbeat on this interval.',
      storeIdLabel: 'Store ID',
      deviceSecret: 'Device Secret',
      generateSecret: 'Generate New Device Secret',
      generatingSecret: 'Generating…',
      generateSecretHint: 'Generate a new secret if the device credentials were lost or compromised.',
      generateSecretFailed: 'Failed to generate device secret.',
      copy: 'Copy',
      secretWarning: 'Copy this secret now. It will not be shown again.',
      qrCode: 'QR Code',
      qrCodeAlt: 'Device secret QR code',
      close: 'Close',
      editConfiguration: 'Edit Configuration',
      configurationTitle: 'Configuration – {name}',
      latestConfigVersion: 'Latest config version: {version} (created at {created})',
    },
    profile: {
      accountInformation: 'Account Information',
      emailNote: 'Your email address cannot be changed here.',
      changePassword: 'Change Password',
      currentPassword: 'Current Password',
      confirmNewPassword: 'Confirm New Password',
      currentPasswordPlaceholder: 'Enter your current password',
      currentPasswordIncorrect: 'Current password is incorrect',
      updateFailed: 'Failed to update password',
      updateSuccess: 'Password updated successfully',
    },
    settings: {
      organizationSettings: 'Organization Settings',
      organizationSettingsDesc: 'Manage your organization settings and team members',
      tabGeneral: 'General',
      tabTeam: 'Team',
      tabWhitelist: 'Whitelist',
      tabBlocked: 'Blocked Customers',
      tabSentinel: 'Sentinel',
      loadLocationsFailed: 'Failed to load locations',
      sentinelPageTitle: 'Sentinel Configuration',
      sentinelPageIntro:
        'Configure PepperShop terminals, detection thresholds, and daily summary delivery for Sentinel.',
      sentinelNoLocations: 'No locations found. Add a location first to configure Sentinel.',
      noOrganizationSelected: 'No organization selected',
      loadOrganizationFailed: 'Failed to load organization details',
      organizationName: 'Organization Name',
      organizationNamePlaceholder: 'Enter organization name',
      organizationNameUpdated: 'Organization name updated successfully',
      organizationNameEmpty: 'Organization name cannot be empty',
      organizationNameTooLong: 'Organization name must be 200 characters or less',
      organizationNameUpdateFailed: 'Failed to update organization name',
      clientIdLabel: 'Client ID',
      clientIdShareHint:
        'Share this ID only with trusted team members to let them request access to your organization.',
      inviteEmailPlaceholder: 'user@example.com',
      switchClient: 'Switch client',
      newOrganization: 'New Organization',
      inviteEmail: 'Email Address',
      inviteRole: 'Role',
      roleManager: 'Manager',
      roleFae: 'FAE',
      roleAdmin: 'Admin',
      sendInvitation: 'Send Invitation',
      sendingInvitation: 'Sending...',
      inviteSuccess: 'Invitation sent successfully!',
      inviteFailed: 'Failed to send invitation',
      // General settings
      general: {
        orgNameLabel: 'Organization Name',
        orgNamePlaceholder: 'Enter organization name',
        orgNameEmpty: 'Organization name cannot be empty',
        orgNameTooLong: 'Organization name must be 200 characters or less',
        updateFailed: 'Failed to update organization name',
        updateSuccess: 'Organization name updated successfully',
      },
      // Team management
      tabRecipients: "Report Recipients",
      recipients: {
        hint: "Manage the report schedule and recipient chat. Contact HumanByte support for provider setup.",
        enabled: "Enable scheduled reports",
        hour: "Delivery hour (0–23)",
        timezone: "Timezone",
        chatId: "Telegram recipient chat ID",
        saved: "Report recipients saved.",
        loadFailed: "Unable to load report recipients.",
        saveFailed: "Unable to save report recipients.",
      },
      roleStaff: "Staff",
      roleShortHints: {
        client_admin: "HumanByte support with full organization access.",
        manager: "Review theft cases, contact customers and manage Staff.",
        fae: "Install and maintain devices; no customer records.",
        staff: "Daily alarm checks and restarts. Customer details visible.",
      },
      roleHints: {
        client_admin: "HumanByte support. Full access; no seat required.",
        manager: "Theft decisions, customer contacts and team invitations. Can remove Staff; no device setup.",
        fae: "Device installation and technical settings. No customer data or Sentinel review.",
        staff: "Daily alarm checks and restarts. Sees customer details; cannot confirm theft or change settings.",
      },
      team: {
        seatSummary: "{used} of {limit} seats used",
        seatFree: "{free} free",
        seatDetails: "Seat details",
        compareRoles: "Compare roles",
        rolePermissions: "Role permissions",
        deliveryRetry: "Email not sent. Retry email delivery.",
        deliveryWaiting: "Sending email. Check again shortly.",
        deliveryReplace: "New invitation required. Revoke this reservation, then invite again.",
        deliveryContact: "Ask the sender or an Admin to recover this invitation.",
        deliverySent: "Email sent; waiting to join.",
        invitationNoLongerPending: "This invitation is no longer pending. Check the team list for current access.",
        seatActiveOne: "{count} active member",
        seatActiveOther: "{count} active members",
        seatPendingOne: "{count} pending invitation",
        seatPendingOther: "{count} pending invitations",
        managerUnavailableOne: "Limit reached ({count} pending invitation)",
        managerUnavailableOther: "Limit reached ({count} pending invitations)",
        seatsUnavailable: "No free seats",
        seatAdmins: "HumanByte support does not use a seat.",
        verifiedAdmin: "Admin — HumanByte support",
        legacyAdmin: "Legacy Admin — review required",
        seatUnverified: "Legacy Admin assignments counted toward seat usage: {count}. Identity review required.",
        deliveryPending: "Invitation reserved; email delivery is pending.",
        retryDelivery: "Retry email delivery",
        deliveryFailed: "Unable to retry email delivery.",
        errors: {
          INVITATION_EXPIRED: "This invitation has expired. Ask your team manager for a new invitation.",
          INVITATION_REVOKED: "This invitation has been revoked.",
          INVITATION_ALREADY_ACCEPTED: "This invitation has already been accepted.",
          EMAIL_MISMATCH: "Sign in with the email address that received this invitation.",
          RECIPIENT_MISMATCH: "Sign in with the email address that received this invitation.",
          NOT_FOUND: "The requested item was not found or is not accessible.",
          FORBIDDEN: "You do not have permission to perform this action.",
          INVALID_INPUT: "Check the submitted organization details.",
          REQUEST_NOT_PENDING: "This join request has already been processed.",
          DELIVERY_RATE_LIMITED: "Please wait before retrying this invitation.",
          INVALID_ROLE: "Choose a valid role.",
          INVALID_EMAIL: "A valid email address is required.",
          INVALID_NAME: "An organization name is required.",
          ORGANIZATION_OPERATION_FAILED: "Unable to update the organization. Please try again.",
          REBOOT_COOLDOWN: "A restart was requested recently. Try again in {seconds} seconds.",
          REVIEW_TRANSITION_NOT_ALLOWED: "Only a Manager or HumanByte Admin can change this theft decision.",
          ROLE_NOT_ALLOWED_INVITE: "Your role cannot invite this role.",
          ROLE_NOT_ALLOWED_APPROVE: "Your role cannot approve a request with this role.",
          ROLE_NOT_ALLOWED_REVOKE: "Your role cannot revoke this invitation.",
          ROLE_NOT_ALLOWED_CHANGE: "Your role cannot change this member’s role.",
          ROLE_NOT_ALLOWED_REMOVE: "Your role cannot remove this member.",

          SEAT_LIMIT_REACHED: "All 5 seats are used, including pending invitations. Remove a member or revoke an invitation to continue.",
          MANAGER_LIMIT_REACHED: "Both Manager positions are used, including pending Manager invitations.",
          LAST_MANAGER_REQUIRED: "The last active Manager cannot be removed or assigned another role.",
          ROLE_NOT_ALLOWED: "Your role does not permit this team action.",
          INVITATION_ALREADY_EXISTS: "This person already has a pending invitation for this organization.",
          MEMBER_ALREADY_EXISTS: "This person already belongs to this organization.",
          INVITATION_ROLE_CONFLICT: "A pending invitation assigns a different role. Revoke it before approving this request.",
          HUMANBYTE_ADMIN_REQUIRED: "Admin access can only be assigned to a verified HumanByte support account.",
          STAFF_NOT_ENABLED: "Staff access is not enabled for this organization yet.",
        },

        loadMembersFailed: 'Failed to load members',
        loadInvitationsFailed: 'Failed to load invitations',
        loadRequestsFailed: 'Failed to load join requests',
        loadFailed: 'Failed to load data',
        inviteMembers: 'Invite Members',
        activeMembers: 'Active Members',
        pendingInvitations: 'Pending Invitations',
        joinRequests: 'Join Requests',
        noPendingInvitations: 'No pending invitations',
        noPendingJoinRequests: 'No pending join requests',
        noMembers: 'No members yet',
        youLabel: '(You)',
        joinedOn: 'Joined {date}',
        invitedOn: 'Invited {date}',
        requestedOn: 'Requested {date}',
        memberActions: 'Member actions',
        changeRole: 'Change Role',
        changeRoleFailed: 'Failed to change role',
        removeMember: 'Remove Member',
        removing: 'Removing...',
        removeConfirm: 'Are you sure you want to remove {email}?',
        removeFailed: 'Failed to remove member',
        approve: 'Approve',
        approving: 'Approving...',
        approveFailed: 'Failed to approve request',
        deny: 'Deny',
        rejectConfirm: 'Are you sure you want to reject this join request?',
        rejectFailed: 'Failed to reject request',
        revoke: 'Revoke',
        revokeConfirm: 'Are you sure you want to revoke this invitation?',
        revokeFailed: 'Failed to revoke invitation',
        selectRole: 'Select Role',
        saving: 'Saving...',
      },
      // Blocked customers
      blocked: {
        loadFailed: 'Failed to load blocked customers',
        addFailed: 'Failed to add blocked customer',
        updateFailed: 'Failed to update blocked customer',
        unblockFailed: 'Failed to unblock customer',
        addSuccess: 'Blocked customer added. Devices will receive updates via config.',
        updateSuccess: 'Blocked customer updated. Devices will receive updates via config.',
        unblockSuccess: 'Customer unblocked. Devices will receive updates via config.',
        customerIdRequired: 'Customer ID is required',
        selectLocationError: 'Please select a location',
        copiedToClipboard: 'Customer ID copied to clipboard',
        copyFailed: 'Failed to copy to clipboard',
        unblockConfirm: 'Are you sure you want to unblock this customer? This action cannot be undone.',
        title: 'Blocked Customers',
        desc: 'Manage blocked customers across all locations in your organization',
        filterByLocation: 'Filter by location',
        filterAll: 'All',
        filterGlobalOnly: 'Global only',
        addTitle: 'Add Blocked Customer',
        listTitle: 'Blocked Customers List',
        noConfigured: 'No blocked customers configured.',
        noMatch: 'No blocked customers match the current filter.',
        colCustomerId: 'Customer ID',
        colLocationScope: 'Location / scope',
        colScope: 'Scope',
        colReason: 'Reason',
        colCreated: 'Created',
        colExpires: 'Expires',
        colActions: 'Actions',
        labelCustomerId: 'Customer ID',
        labelReason: 'Reason (optional)',
        labelExpiresAt: 'Expires At (optional)',
        labelScope: 'Scope',
        labelLocation: 'Location',
        scopeLocation: 'This location only',
        scopeGlobal: 'All locations (client-wide)',
        scopeLocationSpecific: 'Location-specific',
        scopeLocationOnly: 'Location-only',
        scopeGlobalDisplay: 'Global',
        selectLocation: 'Select a location',
        expiresAtPlaceholder: 'Select expiration date and time',
        addBtn: 'Add Blocked Customer',
        adding: 'Adding...',
        loading: 'Loading…',
        editReason: 'Enter reason (optional)',
        expired: '(Expired)',
        saving: 'Saving...',
        saveBtn: 'Save',
        cancelBtn: 'Cancel',
        editBtn: 'Edit',
        unblocking: 'Unblocking...',
        unblockBtn: 'Unblock',
        copyTooltip: 'Copy Customer ID',
      },
      whitelist: {
        emptyNoLocations:
          'No locations found for this organization. Create a location to manage whitelist entries.',
        title: 'Whitelisted Customers',
        desc: 'Manage whitelisted customers across all locations in your organization',
        filterByLocation: 'Filter by location',
        filterAll: 'All',
        filterGlobalOnly: 'Global only',
        addTitle: 'Add Whitelisted Customer',
        listTitle: 'Whitelisted Customers List',
        noConfigured: 'No whitelisted customers configured.',
        noMatch: 'No whitelisted customers match the current filter.',
        colCustomerId: 'Customer ID',
        colLocationScope: 'Location / scope',
        colReason: 'Reason',
        colCreated: 'Created',
        colActions: 'Actions',
        labelCustomerId: 'Customer ID',
        labelReason: 'Reason (optional)',
        labelScope: 'Scope',
        labelLocation: 'Location',
        scopeGlobal: 'All locations (client-wide)',
        scopeLocationSpecific: 'Location-specific',
        selectLocation: 'Select a location',
        selectLocationError: 'Please select a location',
        customerIdRequired: 'Customer ID is required',
        adding: 'Adding...',
        addBtn: 'Add Whitelisted Customer',
        loading: 'Loading…',
        editReasonPlaceholder: 'Enter reason (optional)',
        saving: 'Saving...',
        saveBtn: 'Save',
        cancelBtn: 'Cancel',
        editBtn: 'Edit',
        removing: 'Removing...',
        removeBtn: 'Remove',
        removeConfirm:
          'Are you sure you want to remove this whitelist entry? This action cannot be undone.',
        copyTooltip: 'Copy Customer ID',
        copiedSuccess: 'Customer ID copied to clipboard',
        copyFailed: 'Failed to copy to clipboard',
        loadFailed: 'Failed to load whitelisted customers',
        addFailed: 'Failed to add whitelisted customer',
        updateFailed: 'Failed to update whitelisted customer',
        removeFailed: 'Failed to remove whitelisted customer',
        addSuccess: 'Whitelisted customer added. Devices will receive overrides via config.',
        updateSuccess: 'Whitelisted customer updated. Devices will receive overrides via config.',
        removeSuccess: 'Whitelisted customer removed. Devices will receive updated config on next sync.',
        scopeGlobalDisplay: 'Global',
        // Service accounts
        serviceTitle: 'Create Service Account',
        serviceDesc: 'Create an operational service account for QR-based access. Service account IDs must use the SVC- namespace.',
        serviceCsvGuidance: 'If this ID must exist in PepperShop, import the CSV there before distributing the QR. Door access uses the existing device whitelist sync, so no edge firmware update is required.',
        serviceKundenNr: 'Kunden-Nr',
        serviceKundenNrPlaceholder: 'SVC-',
        serviceKundenNrHelp: 'Required format: SVC- followed by letters, numbers, or hyphens.',
        serviceKundenNrRequired: 'Kunden-Nr is required',
        serviceFirma: 'Firma',
        serviceVorname: 'Vorname',
        serviceNachname: 'Nachname',
        serviceCreating: 'Creating...',
        serviceCreateBtn: 'Create Service Account',
        serviceCreateFailed: 'Failed to create service account',
        serviceCreateSuccess: 'Service account created. Download the QR PNG or CSV for operational use.',
        downloadQrPng: 'Download QR PNG',
        downloadCsv: 'Download CSV',
        colDisplayName: 'Display name',
        colType: 'Type',
        typeServiceAccount: 'Service Account',
        typeCustomer: 'Customer',
        qrBtn: 'QR',
        csvBtn: 'CSV',
      },
    },
    logs: {
      filtersUnavailable: 'Location and timezone settings are unavailable. Retry before changing the investigation filters.',
      unappliedFilters: 'Changes not applied. Results below still use your previous filters.',
      liveResults: "Live scan events: new arrivals may change pages and totals. Refresh to reload.",
      investigationTimezone: "Investigation timezone",
      fromRepeatedTime: 'From repeated time',
      toRepeatedTime: 'To repeated time',
      repeatedTimeHint: '{civil} occurs twice in {timezone}. Choose which one you mean.',
      beforeClocksMoveBack: '{time} — before clocks move back ({offset})',
      afterClocksMoveBack: '{time} — after clocks move back ({offset})',
      invalidTimezone: 'Enter a valid investigation timezone.',
      malformedBound: 'Enter {field} as YYYY-MM-DDTHH:mm or use the calendar button.',
      nonexistentBound: 'This {field} time does not exist in {timezone} because clocks move forward.',
      ambiguousBound: 'Choose whether {field} is before or after clocks move back.',
      reversedRange: 'To must be at or after From.',
      dateTimePlaceholder: 'Choose date and time',
      allLocations: 'All locations',
      allResults: 'All results',
      allIssueTypes: 'All issue types',
      customerIdHelp: 'Matches the complete Customer ID.',
      issueUserBlocked: 'User blocked',
      issueClockInvalid: 'Device clock invalid',
      issueWhitelistOverride: 'Whitelist override',
      issueOutOfHours: 'Outside operating hours',
      issueUserNotFound: 'User not found',
      issueOfflineMode: 'Offline mode',
      issueCacheMissOffline: 'Not cached while offline',
      issueNetworkError: 'Network error',
      issueRelayFailure: 'Relay failure',
      issueSystemError: 'System error',
      issueBytekeySnapshotUnavailable: 'ByteKey snapshot unavailable',
      issueBytekeyLegacyOnly: 'Access granted by legacy validation',
      loadFailed: "Results unavailable. Please retry.",
      fromOccurrence: "From: repeated-hour occurrence",
      toOccurrence: "To: repeated-hour occurrence",
      chooseIfRepeated: "Choose if this hour repeats",
      earlierOccurrence: "First occurrence",
      laterOccurrence: "Second occurrence",
      chooseDateTime: 'Choose',
      dateAndTime: 'date and time',
      pickerHour: 'Hour',
      pickerMinute: 'Minute',
      boundsHint: "Dates and times use the investigation timezone. Both endpoints are included; 03:00 means exactly 03:00:00.",
      timezoneConflict: "Configured and detected store timezones differ. The investigation timezone above determines this search.",
      invalidRange: "Check the timezone and date range. A skipped clock time is invalid; for a repeated hour choose its first or second occurrence.",
      applyFilters: "Apply filters",
      customInterval: "Access activity (selected interval)",
      overviewHint: "Recent overview; the unbounded logs table may cover a different period.",
      chartBothBounds: "Select both From and To to chart an exact investigation interval.",
      summaryFailed: "Chart unavailable. Check the range and granularity, or retry.",

      title: 'Access Logs',
      colorCoding:
        'Color coding: Red rows = hardware/network issues, Yellow = user/business rule issues, Green badge = successful access.',
      refresh: 'Refresh',
      location: 'Location',
      result: 'Result',
      issueType: 'Issue Type',
      from: 'From',
      to: 'To',
      all: 'All',
      clearFilters: 'Clear filters',
      startDate: 'Select start date and time',
      endDate: 'Select end date and time',
      tabLogs: 'Logs',
      tabTrends: 'Trends',
      tabsAria: 'Logs view',
      colTime: 'Time',
      colStore: 'Store',
      colCustomerId: 'Customer ID',
      notAvailable: 'N/A',
      unknownStore: 'Unknown',
      resultGranted: 'Granted',
      resultDenied: 'Denied',
      resultError: 'Error',
      noLogsFound: 'No logs found',
      chartTotal: 'Total',
      // Access logs chart
      chartHourTitle: 'Access activity (last hour)',
      chartDayTitle: 'Access activity (last 24h)',
      chartWeekTitle: 'Access activity (last 7 days)',
      chartMonthTitle: 'Access activity (last 30 days)',
      chartYearTitle: 'Access activity (last year)',
      chartHourTooltip: 'Hour view — last 60 minutes',
      chartDayTooltip: 'Day view — last 24 hours',
      chartWeekTooltip: 'Week view — last 7 days',
      chartMonthTooltip: 'Month view — last 30 days',
      chartYearTooltip: 'Year view — last 12 months',
      chartGranHour: 'H',
      chartGranDay: 'D',
      chartGranWeek: 'W',
      chartGranMonth: 'M',
      chartGranYear: 'Y',
      chartNow: 'now',
      tzHint:
        "Bucket boundaries and labels use this timezone: the selected store's local time, your stores' shared local time when they all match, or UTC when they span multiple zones.",
      noAccessEvents: 'No access events in this window.',
    },
    onboarding: {
      setupOrganization: "Create your organization and start managing your team.",
      completeTitle: "Your organization is ready",
      completeManagerHint: "You are the first Manager. Manage your team now; HumanByte support or an FAE will handle technical device setup.",
      openTeam: "Open team settings",

      welcome: 'Welcome to ByteGate',
      startChoice: 'Get started by creating or joining an organization',
      requestAccess: 'Request access to an organization',
      setupOrgLocation: "Let's set up your organization and first location",
      organization: 'Organization',
      firstLocation: 'First location',
      choosePath: 'Choose Your Path',
      choosePathDesc: 'Create a new organization or join an existing one',
      createOrg: 'Create New Organization',
      createOrgDesc: 'Start fresh with your own organization and manage your team',
      joinOrg: 'Join Existing Organization',
      joinOrgDesc: 'Request access to join an organization using the Client ID',
      businessName: 'Business Name',
      businessPlaceholder: 'Acme Retail',
      businessHint: 'This will be your organization name in ByteGate',
      continue: 'Continue',
      creating: 'Creating...',
      locationName: 'Location name',
      locationPlaceholder: 'Main Street Branch',
      locationHint: 'This will be your first physical location',
      createLocation: 'Create location',
      createLocationFailed: 'Failed to create location',
      pendingInvitesTitle: 'You have pending invitations',
      pendingInvitesDesc:
        'Join an existing organization that has already invited you, or continue with a new setup.',
      openInvitationEmail: "Open the link in your invitation email to join.",
      invitedAs: 'Invited as {role} to {email}',
      acceptInvite: 'Accept Invite',
      joinRequestSent: 'Join Request Sent',
      joinRequestSentDesc:
        "Your request is waiting for the organization administrator to review. Check back here for access.",
      cancelRequestCreateOrg: 'Cancel Request & Create New Org',
      cancelRequest: 'Cancel request',
      cancellingRequest: 'Cancelling…',
      cancelRequestFailed: 'Unable to cancel your request. Please try again.',
      organizationClientId: 'Organization Client ID',
      clientIdHint: 'Enter the Client ID provided by the organization administrator',
      invalidClientId: 'Please enter a valid Client ID (UUID format)',
      joinRequestFailed: 'Failed to send join request',
      sendRequest: 'Send Request',
    },
    invite: {
      verifyingTitle: 'Verifying Invitation',
      verifyingHint: 'Please wait...',
      invalidTitle: 'Invalid Invitation',
      alreadyAccepted: 'This invitation has already been accepted.',
      expired: 'This invitation has expired. Please request a new invitation.',
      invalid: 'This invitation link is invalid or no longer exists.',
      verifyFailed: 'Unable to verify this invitation.',
      emailMismatchTitle: 'Email Mismatch',
      emailMismatchHint: 'Please sign out and log in with the email address that received this invitation.',
      emailMismatchBody: "This invitation is for {invitedEmail}, but you are logged in as {currentEmail}.",
      signOutSwitch: 'Sign Out and Switch Account',
      invitedTitle: "You've been invited!",
      invitedBody: 'has invited you to join as a',
      invitedHint: 'Create a new account or sign in with',
      invitedHintEnd: 'to accept this invitation.',
      createAccountToAccept: 'Create Account to Accept',
      signInToAccept: 'Sign In to Accept',
      acceptTitle: 'Accept Invitation',
      acceptCta: 'Accept Invitation',
      accepting: 'Accepting...',
      acceptFailed: 'Failed to accept invitation',
      roleAdmin: 'Admin',
      roleFae: 'FAE',
      roleManager: 'Manager',
    },
    sentinel: {
      title: 'Sentinel',
      description: 'Daily store review generated from overnight entry and POS payment analysis.',
      releaseGateHidden: 'Sentinel daily review is currently hidden by the release gate.',
      updateAlertFailed: 'Failed to update alert',
      saveFailed: 'Save failed.',
      testFailed: 'Test failed.',
      // Status labels
      statusPending: 'Pending Review',
      statusFalseAlarm: 'False Alarm',
      statusConfirmedTheft: 'Confirmed Theft',
      statusSuspectedTheft: 'Suspected Theft',
      statusAutoDismissed: 'Auto-Dismissed',
      // Sync health banner
      syncDegraded: '⚠️ PepperShop sync is degraded — anomaly detection paused',
      lastSync: 'Last successful sync:',
      neverSynced: 'Never synced',
      consecutiveFailures: 'consecutive failure(s)',
      // Alert list filters / table
      allLocations: 'All locations',
      alertFilterStatus: 'Status',
      alertFilterLocation: 'Location',
      filterAll: 'All',
      noAlertsFound: 'No alerts found',
      noPendingAlerts: 'No pending alerts — all activity looks normal.',
      noFilteredAlerts: 'No alerts match the current filters.',
      colEntryTime: 'Entry Time',
      colLocation: 'Location',
      colCustomer: 'Customer',
      colStats: 'Stats',
      colStatus: 'Status',
      colAction: 'Action',
      reviewAction: 'Review →',
      // Owner trend (entries vs payments vs alerts)
      metricTileGap: 'Gap',
      metricTileGapHint:
        'Granted entries minus POS order count in this period (floored at zero). Some gap is normal — browsers, returns, accompanying guests. A growing gap vs. the previous period is worth watching.',
      metricTileEntries: 'Entries (granted)',
      metricTileEntriesShort: 'Entries',
      metricTilePayments: 'Payments',
      metricTileAlerts: 'Alerts',
      ownerTrendTooltipGap: 'Gap (entries − payments): {value}',
      ownerTrendTooltipUniqueCustomers: 'Unique customers (granted)',
      ownerTrendTooltipWhitelistOverride: 'Whitelist override: {count}',
      paymentsAttributionFallback:
        'Payments show all organization orders (link PepperShop terminals in Sentinel location settings to filter).',
      alertsTooltipReviewHint: 'Click a red dot to review.',
      alertDotPopoverTitle: 'Alerts',
      alertDotViewAll: 'View all {count} alerts in this period',
      alertDotAriaLabel: 'Open {count} alert(s) at {label}',
      ownerTrendHourly: 'Activity (last hour)',
      ownerTrendDaily: 'Activity (last 24h)',
      ownerTrendWeekly: 'Activity (last 7 days)',
      ownerTrendMonthly: 'Activity (last 30 days)',
      ownerTrendYearly: 'Activity (last 12 months)',
      ownerTrendHourlyTooltip: 'Hour view — last 60 minutes',
      ownerTrendDailyTooltip: 'Day view — last 24 hours',
      ownerTrendWeeklyTooltip: 'Week view — last 7 days',
      ownerTrendMonthlyTooltip: 'Month view — last 30 days',
      ownerTrendYearlyTooltip: 'Year view — last 12 months',
      alertTrendTzHint:
        "Bucket boundaries and labels use this timezone: the selected location's local time, your locations' shared local time when they all match, or UTC when they span multiple zones.",
      alertTrendAnchorHint: 'Pick a day to view the trend ending on that date',
      alertTrendAnchorAria: 'Trend end date',
      alertTrendNow: 'Now',
      noOwnerEventsHourly: 'No entries, payments, or alerts in the last hour.',
      noOwnerEventsDaily: 'No entries, payments, or alerts in the last 24 hours.',
      noOwnerEventsWeekly: 'No entries, payments, or alerts in the last 7 days.',
      noOwnerEventsMonthly: 'No entries, payments, or alerts in the last 30 days.',
      noOwnerEventsYearly: 'No entries, payments, or alerts in the last 12 months.',
      alerts: 'alerts',
      // Alert detail — header & stats
      unknownLocation: 'Unknown location',
      entryDetectedAt: 'Entry detected at',
      customerLabel: 'Customer:',
      entriesInWindow: 'Entries in window',
      anonymousPayments: 'Anonymous payments',
      windowDuration: 'Window duration',
      minSuffix: 'min',
      // Alert detail — investigation guide
      activityTimeline: 'Activity Timeline',
      cctvGuide: 'CCTV Investigation Guide',
      step1Title: 'Locate entry footage',
      step1Desc: 'Review CCTV starting exactly at',
      step1End: 'at the front door/entry scanner.',
      step2PaymentsTitle: 'Anonymous payments during window',
      step2Desc: 'Follow the customer and check if they match any of these transactions at the POS terminal.',
      colTimeLocal: 'Time (local)',
      colPaymentMethod: 'Payment Method',
      colItems: 'Items',
      step3Title: 'Make your determination',
      step3Desc: 'Does the camera footage show the customer leaving with goods they did not pay for?',
      // Alert detail — review panel
      recordDetermination: 'Record Your Determination',
      notesLabel: 'Notes (optional)',
      notesPlaceholder: 'Describe what you observed on the CCTV footage...',
      falseAlarmBtn: '✅ False Alarm',
      addToBlockedList: 'Add to blocked list',
      confirmedTheftBtn: '🚨 Confirmed Theft',
      reviewedOn: 'Reviewed on',
      reviewed: 'Reviewed.',
      alertDetail: 'Alert Detail',
      legacyReadOnly: 'Legacy Sentinel v1 alert retained for historical review. Review actions are disabled.',
      // Timeline chart
      unknownItems: 'Unknown items',
      entryEvent: 'Entry Event',
      paymentEvent: 'Payment Event',
      posPayment: 'POS Payment',
      suspicionWindow: 'Suspicion Window',
      noTimelineEvents: 'No entry or payment events in this timeline window.',
      timelineWindowDesc: 'Timeline window: 10 min before entry → 20 min after',
      timelineItem: 'Item',
      timelineEntry: 'Entry',
      timelineBounds: 'Timeline window:',
      closeDetails: 'Close',
      timelineUnavailableEvents: 'Some events cannot be placed on this timeline. Check their details in the investigation guide.',
      timelineTimeUnavailable: 'Time unavailable',
      methodLabel: 'Method:',
      amountLabel: 'Amount:',
      itemsLabel: 'Items:',
      // Config form — PepperShop credentials
      pepperShopIntegration: 'PepperShop Integration',
      pepperShopDesc: 'Applies to all locations in your organization. Credentials are encrypted at rest.',
      syncFailing: '⚠️ Sync is currently failing',
      baseUrl: 'Base URL',
      apiUsername: 'API Username',
      apiKey: 'API Key',
      leaveBlankExisting: 'leave blank to keep existing',
      enterApiKey: 'Enter API key',
      hide: 'Hide',
      show: 'Show',
      saving: 'Saving…',
      saveCredentials: 'Save Credentials',
      testing: 'Testing…',
      testConnection: 'Test Connection',
      credentialsSaved: 'Credentials saved successfully.',
      connectionSuccess: 'Connection successful — PepperShop API is reachable.',
      // Config form — store section
      configSaved: 'Configuration saved.',
      testMessageSent: 'Test message sent! Check your Telegram channel.',
      enabled: 'Enabled',
      disabled: 'Disabled',
      botToken: 'Bot Token',
      enterBotToken: 'Enter bot token from @BotFather',
      chatId: 'Chat / Channel ID',
      windowMinutes: 'Window (minutes)',
      marginOfError: 'Margin of error',
      alertingEnabled: 'Daily summary enabled',
      muteWindowsLabel: 'Mute Windows (Peak Hours)',
      addMuteWindow: '+ Add',
      muteWindowsDesc: 'Suppress alerts during high-traffic periods to reduce false positives.',
      noMuteWindows: 'No mute windows configured.',
      muteWindowTo: 'to',
      remove: 'Remove',
      save: 'Save',
      sending: 'Sending…',
      sendTestMessage: 'Send Test Message',
      locationAlertConfigs: 'Location monitoring configurations',
      locationAlertConfigsDesc:
        'Scan all locations below, then open one to edit daily summary delivery, detection thresholds, terminals, and quiet hours.',
      locationConfigSummaryFootnote:
        'Each row shows the current draft for that location. Save inside a location applies only that location.',
      locationConfigColAlerts: 'Summary',
      locationConfigColWindow: 'Window',
      locationConfigColCount: 'Count',
      locationConfigColTelegram: 'Telegram',
      locationConfigColTerminals: 'Terminals',
      locationConfigConfigure: 'Configure',
      locationConfigColExpand: 'Expand',
      locationConfigClose: 'Close',
      locationConfigSectionNotify: 'Notifications',
      locationConfigSectionNotifyDesc: 'Turn daily summaries on, set where messages go, and rotate the bot token if needed.',
      locationConfigSectionDetect: 'Detection',
      locationConfigSectionTerminals: 'Match payments',
      locationConfigQuietHoursToggle: 'Quiet hours (mute windows)',
      locationConfigQuietHoursClosed: 'Optional — expand to add peak-hour suppression',
      locationConfigTelegramOk: 'Chat set',
      locationConfigTelegramMissing: 'No chat',
      locationConfigTerminalsAllOrg: 'All org',
      locationConfigTerminalsCount: '{count} selected',
      locationConfigCountUniqueShort: 'Unique',
      locationConfigTerminalsCountShort: '{count}',
      // Day names for mute window dropdowns
      dayMonday: 'Monday',
      dayTuesday: 'Tuesday',
      dayWednesday: 'Wednesday',
      dayThursday: 'Thursday',
      dayFriday: 'Friday',
      daySaturday: 'Saturday',
      daySunday: 'Sunday',
      // Unique customer count + count mode
      uniqueCustomers: 'Unique customers',
      countMode: 'Count mode',
      countModeEntries: 'Total entries',
      countModeUniqueCustomers: 'Unique customers',
      countModeDesc: 'Compare anonymous payments against total entries or unique customers in the window.',
      // Customer IDs modal
      windowCustomersTitle: 'Customers in window',
      windowCustomersDesc: 'All unique customer IDs from the alert time window',
      windowCustomersEmpty: 'No customer IDs available for this window.',
      customerIdTooltip: 'Click to view all customers in this window',
      // Stats column format
      statUnique: 'unique',
      statIn: 'in',
      statPaid: 'paid',
      // Timeline chart — payment type distinction
      anonPaymentEvent: 'Anonymous Payment',
      identifiedPaymentEvent: 'Identified Payment',
      identifiedPaymentNote: 'Customer paid — not counted as anonymous',
      posTerminalIds: 'POS Terminal IDs',
      posTerminalIdsDesc: "Select which PepperShop terminals belong to this location. Only payments from these terminals count toward the detection window. If your location has multiple cashier lanes, add all their IDs here.",
      posTerminalIdsFetch: 'Load from PepperShop',
      posTerminalIdsFetching: 'Loading terminals…',
      posTerminalIdsFetchError: 'Could not load terminal IDs from PepperShop. Enter them manually below.',
      posTerminalIdsFetchEmpty: 'No terminals found in the last 90 days of orders. Enter IDs manually below.',
      posTerminalIdsManualLabel: 'Add terminal ID manually',
      posTerminalIdsManualPlaceholder: 'e.g. 3',
      posTerminalIdsManualAdd: 'Add',
      posTerminalIdsSelected: 'Active terminals',
      posTerminalIdsNone: 'No terminals configured — all payments for your organization will be counted (use this only if you have a single location).',
      posTerminalIdsRemove: 'Remove terminal {id}',
      recap: {
        settingsTitle: 'Recap settings',
        enableDailyRecap: 'Enable daily recap',
        sendHour: 'Send hour',
        timezone: 'Timezone',
        sendToTelegram: 'Send to Telegram',
        botToken: 'Bot token',
        botTokenConfiguredPlaceholder: 'Configured — leave blank to keep existing token',
        botTokenEnterPlaceholder: 'Enter bot token',
        chatId: 'Chat ID',
        chatIdPlaceholder: 'e.g. -1001234567890',
        testTelegramButton: 'Send test message',
        testTelegramSending: 'Sending test…',
        testTelegramSuccess: 'Test message sent. Check your Telegram channel.',
        testTelegramFailed: 'Test failed.',
        saveButton: 'Save',
        saveButtonSaving: 'Saving…',
        saveSuccess: 'Saved.',
        saveFailed: 'Save failed.',
        statusEnabled: 'Enabled',
        statusDisabled: 'Disabled',
        collapseHint: 'Click to collapse settings',
        expandHint: 'Click to expand settings',
        telegramFailedBanner: '{count} consecutive Telegram notification(s) failed.',
        previewTitle: 'Today',
        previewSubtitleLive: 'Live preview',
        previewSubtitleDaily: 'Daily report',
        recomputeAria: 'Recompute report',
        asOfLabel: 'Updated {time} ({timezone})',
        refreshAria: 'Refresh preview',
        locationCountSingular: '1 location',
        locationCountPlural: '{count} locations',
        previewUnavailable: 'Preview unavailable.',
        coverageLabel: 'Payment coverage',
        coverageHeroSummary: '{payments} payments across {unique} unique customers who entered today.',
        coveragePercent: '{pct}%',
        thresholdLegend: 'Thresholds: ≥70% paid vs unique → Normal. 40–70% → Watch. Below 40% → Concerning.',
        metricEntries: 'Entries',
        metricUnique: 'Unique customers',
        metricPayments: 'Payments',
        metricCoverage: 'Coverage',
        vs7dBaseline: '{days}-day avg.',
        noBaselineYet: 'Not enough history for comparison yet.',
        perLocationTitle: 'Per-location activity',
        colLocation: 'Location',
        colEntries: 'Entries',
        colUnique: 'Unique',
        colGranted: 'Granted',
        colDenied: 'Denied',
        colErrors: 'Errors',
        colPayments: 'Payments',
        paymentsUnattributedTooltip:
          'Link this location’s PepperShop terminal (cashier) IDs in Sentinel location settings to attribute POS payments. Totals row still reflects all organization payments.',
        deniedAttentionTooltip: 'This location recorded denied accesses today — tap to investigate.',
        openLocationAria: 'Open location {name}',
        sortHint: 'Click a column heading to sort',
        evalNormal: 'Normal',
        evalWatch: 'Watch',
        evalConcerning: 'Concerning',
        last7DaysTitle: 'Last 7 days',
        noRecapsYet: 'No recaps saved yet. System recaps generate each morning.',
        telegramSentLabel: 'Telegram delivered',
      },
      tabAlerts: 'Alerts',
      tabRecap: 'Recap',
      tabWeekReview: 'Week Review',
      tabLegacyAlerts: 'Legacy Alerts',
      v2: {
        awaitingManager: "Triaged — awaiting Manager decision.",
        reviseDecision: "Change decision",
        previousWeek: "Previous week",
        nextWeek: "Next week",
        weekStarting: "Week starting",
        makeDecision: "Make decision",
        saveNotes: "Save notes",
        triageTitle: "Record what you observed",
        triageGuidance: "Check the camera footage, times and payment evidence. Add notes about any mismatch for Manager review. Customer identification and the final decision are handled by a Manager.",
        triageOutcomeTitle: "Complete your triage",
        triageOutcomeGuidance: "Close a false alarm when the evidence explains the mismatch, or send your observations for a Manager decision.",
        closeFalseAlarm: "Close as false alarm",
        sendManagerReview: "Send for Manager review",
        triaged: "Triaged",
        awaitingManagerCount: "Awaiting Manager",
        decisionResolved: "Decision resolved",
        checklistDone: "Daily checks complete",

        reanalysisDisabled: 'Reanalysis is currently disabled. Existing reports remain available.',
        reanalysisConflict: 'The preview is no longer valid, or the report, reviews or settings changed. Create a new preview before continuing.',
        reanalysisPaused: 'Analysis is paused. Resume analysis before requesting reanalysis.',
        reanalysisEnrollment: 'This organization has not enabled the new analysis. Complete enablement before requesting reanalysis.',
        visitsPayments: '{entries} eligible visits · {payments} payments',
        shortfall: 'Unmatched visits',
        reanalysisIntervalUnavailable: 'Reporting interval unavailable. Create a new preview.',
        reportingInterval: 'Reporting interval',
        incompleteEvidence: 'Incomplete evidence — verify CCTV and payment records before deciding.',
        deadlineReason: 'The launch deadline was reached while boundary activity was still unresolved.',
        snapshotCaptured: 'Snapshot captured',
        incomingEvidence: 'Unresolved evidence from the preceding reporting interval. Review the earlier report or ask an administrator to preview reanalysis.',
        lastFinalizedReport: 'Last finalized report',
        distinctCustomers: 'Distinct eligible customers',
        legacyCalendar: 'Legacy calendar-day calculations',
        legacyOperational: 'Legacy operational calculations',
        finalizedPending: 'Finalized report pending.',
        finalizedReport: 'Finalized operational report',
        operationalReport: 'Operational report',
        incompleteReport: 'Evidence incomplete — manual verification required.',
        rawEntries: 'Raw entries',
        grantedReport: 'Granted',
        deniedReport: 'Denied',
        errorsReport: 'Errors',
        eligibleVisits: 'Eligible visits',
        periodPayments: 'Period payments',
        ownedAnomalies: 'Owned-window anomalies',
        needsVerification: 'Needs manual verification',
        paymentsPerCustomer: 'Payments per distinct eligible customer',
        unavailableReport: 'unavailable',
        historicalReinterpretation: 'Historical data interpreted using the configuration approved for this analysis.',
        supersededNotice: 'This evidence has been superseded. Its original review and notes are preserved; it is read-only.',
        openCurrentReport: 'Open current report',
        openReplacementWindow: 'Open replacement window',
        reanalysisSelected: "Selected reporting periods",
        reanalysisUnavailable: "Unavailable",
        reanalysisFailed: "Reanalysis request failed. Existing reports are unchanged.",
        reanalysisRaw: "Raw entries",
        reanalysisVisits: "Eligible visits",
        reanalysisCustomers: "Distinct eligible customers",
        reanalysisPayments: "Period payments",
        reanalysisAnomalies: "Anomalies",
        reanalysisTitle: "Reanalyze selected periods",
        reanalysisScope: "Select inclusive reporting-period start dates (05:00 to 05:00 in the reporting timezone). Current configuration will be used; existing reviews and notes are preserved.",
        reanalysisFrom: "First reporting period",
        reanalysisTo: "Last reporting period",
        reanalysisPreview: "Preview impact",
        reanalysisAffected: "Affected reports",
        reanalysisReviewed: "Reviewed windows / stores",
        reanalysisRange: "Dependency range",
        reanalysisEstimate: "Estimated provider pages",
        reanalysisExpires: "Preview expires",
        reanalysisCompareOnly: "Comparison first: reports will remain unchanged until you approve publication.",
        reanalysisApprove: "Approve reanalysis",
        reanalysisQueued: "Queued; existing reports remain available.",
        reanalysisExpand: "Select required dependency range and preview again",
        reanalysisPeriod: "Reporting period",
        reanalysisMetric: "Metric",
        reanalysisBefore: "Before",
        reanalysisAfter: "After",
        reanalysisChangedReviews: "Changed reviewed windows",
        reanalysisTheft: "Theft decisions requiring review",
        reanalysisSent: "Previously sent Telegram reports remain unchanged",
        reanalysisActualPages: "Provider pages used",
        reanalysisWindows: "New / removed / merged windows",
        reanalysisDownload: "Download comparison and source allocations",
        reanalysisPublish: "Publish reviewed comparison",
        historyFailed: "Could not load report history.",
        historyTitle: "Report history",
        historyEmpty: "No saved revisions.",
        historyActive: "Active",
        historyArchived: "Archived",
        historyMore: "Load more revisions",
        historyLegacy: "Legacy snapshot: only originally stored values are available.",
        historyLegacyEntries: "Stored unique entries",
        reanalysisState_previewed: "Preview ready",
        reanalysisState_queued: "Queued",
        reanalysisState_staged: "Comparison ready",
        reanalysisState_published: "Published",
        reanalysisState_failed: "Failed; existing reports remain available.",
        reanalysisState_blocked: "Blocked; existing reports remain available.",

        // Upgrade notice
        upgradeTitle: 'Sentinel now uses daily analysis.',
        upgradeBody:
          'The dashboard shows pre-calculated detection windows for completed operational days. Live v1 polling and per-alert noise are no longer part of the normal review workflow.',
        // Batch status banner
        batchMissingConfig: 'Daily analysis is available, but one or more locations need terminal configuration.',
        batchCompleted: 'Daily analysis completed. Review suspicious windows below.',
        batchRunning: 'Daily analysis is being prepared.',
        batchFailed: 'Daily analysis failed. Admin review is required.',
        batchMissing: 'No daily analysis is available for this day yet.',
        batchNeverRan: 'Daily analysis has never run — payment and review data will be empty until the batch runs.',
        batchStale: 'Daily analysis last completed {age}. Payment data may be stale — the daily batch may not be running.',
        batchWaitingUntil: 'Waiting until {time} before the daily payment snapshot.',
        batchWaiting: 'Waiting for the next readiness check.',
        batchStartedLate: 'This analysis started after its scheduled launch deadline.',
        batchOverdue: 'The scheduled launch is overdue. The reporting interval has not changed.',
        batchPreviousAvailable: 'The previous finalized report remains available while this attempt needs attention.',
        batchStaleHint: 'Payment data comes from the daily snapshot. Check the scheduled analysis, then preview selected dates for reanalysis.',
        batchOperationalDay: 'Operational day: {date}',
        batchBasedOnNote: 'Daily review is based on completed batch analysis, not live polling.',
        runAnalysis: 'Run analysis',
        runningAnalysis: 'Running…',
        retry: 'Retry',
        ageLessThanHour: 'less than an hour ago',
        ageHourOne: '1 hour ago',
        ageHours: '{n} hours ago',
        ageDayOne: '1 day ago',
        ageDays: '{n} days ago',
        // Week view
        weekReview: 'Week Review',
        loadWeekFailed: 'Failed to load week',
        loadWindowsFailed: 'Failed to load detection windows',
        loadWindowFailed: 'Failed to load detection window',
        loadingWindow: 'Loading detection window',
        windowNotFound: 'Detection window not found.',
        backToSentinel: 'Back to Sentinel',
        reportTitle: 'Detection window report',
        openReport: 'Open report',
        openReportNewTab: 'Open report in new tab',
        loadDayFailed: 'Failed to load detection data',
        retryBatchFailed: 'Failed to retry batch',
        reviewUpdateFailed: 'Could not update review status. Please try again.',
        anomaliesCount: '{count} anomalies',
        entriesPayments: '{entries} entries · {payments} payments',
        locationFallback: 'Location',
        // Store day view
        backToWeek: 'Week view',
        storeDaySummary: '{entries} entries · {payments} payments · {anomalies} suspicious windows',
        reviewedBadge: 'Daily checks complete',
        markReviewed: 'Complete daily checks',
        colWindow: 'Window',
        colEntries: 'Entries',
        colPayments: 'Payments',
        colDuration: 'Duration',
        colStatus: 'Status',
        noWindowsMatch: 'No detection windows match this view.',
        pageLabel: 'Page {page}',
        // Window detail
        backToWindows: 'Detection windows',
        detectionWindow: 'Detection Window',
        uniqueEntries: 'Unique entries',
        margin: 'Margin',
        selectCustomerFirst: 'Select the customer confirmed by CCTV before recording theft.',
        reviewFailed: 'Failed to record review',
        blockPropagated: 'Customer added to the blocked list. Store devices updated on',
        blockPending: 'Customer is on the blocked list, but the store devices have not been updated yet. This is retried automatically.',
        blockRetry: 'Update devices now',
        blockRetrying: 'Updating devices…',
        blockRetryFailed: 'Store devices could not be updated. Try again later.',
        notesSaveFailed: 'Failed to save notes',
        step1From: 'Review CCTV from',
        step1To: 'to',
        step2Title: 'Anonymous payments in this window',
        step2Desc: 'Follow the customer on camera and check if they match any of these POS transactions.',
        noAnonPayments: 'No anonymous payments in this window.',
        colTime: 'Time',
        colMethod: 'Method',
        colPayment: 'Payment',
        windowStart: 'Window start',
        entryReference: 'Entry {label} · {time}',
        noCustomerSelected: 'No customer selected',
        selectedCustomer: 'Selected customer',
        confirmedCustomer: 'Confirmed customer',
        copyCustomerIdFailed: 'Could not copy customer ID.',
        step3Title: 'Identify the customer',
        step3Desc: 'Select the customer you identified on the footage.',
        noCustomerIds: 'No customer IDs in this window.',
        copyCustomerId: 'Copy full customer ID',
        step4Title: 'Make your determination',
        step4Desc: 'Does the footage show the customer leaving with goods they did not pay for?',
        notesPlaceholder: 'Notes — describe what you observed on the footage…',
        blockCustomerToggle: 'Add selected customer to blocked list',
        editNotes: 'Edit notes',
        addNotesPlaceholder: 'Add review notes…',
        // Day view
        dayBack: 'Back',
        dailyRecapHeading: 'Daily Recap',
        noDailyRecap: 'No daily recap for this date.',
        detectionWindowsHeading: 'Detection Windows',
        noDetectionData: 'No detection data for this date.',
        reviewedDone: 'Done',
      },
    },
    locations: {
      operatingHours: {
        title: 'Operating Hours',
        descBefore: 'Define when this location is considered open in',
        descAfter: '. Whitelisted customers can still enter outside these hours, but standard access follows this schedule.',
        locationLocalTime: 'location local time',
        mode: 'Mode',
        mode247Title: 'Open 24/7',
        mode247Desc: 'Location is always considered open. Best for 24/7 sites.',
        mode247Note: 'Location is treated as open at all times. Use this for 24/7 sites (e.g. bars, late-night gyms).',
        modeCustomTitle: 'Custom weekly hours',
        modeCustomDesc: 'Set different open and close times per day.',
        colDay: 'Day',
        colStatus: 'Status',
        colOpen: 'Open',
        colClose: 'Close',
        colEdit: 'Edit',
        dayOpen: 'Open',
        dayClosed: 'Closed all day',
        markClosedLabel: 'Mark day as closed',
        markOpenLabel: 'Mark day as open',
        editBtn: 'Edit',
        doneBtn: 'Done',
        saving: 'Saving…',
        saveBtn: 'Save Operating Hours & Push to Device',
        noChanges: 'No changes to save',
        updateFailed: 'Failed to update operating hours',
        updateSuccess: 'Operating hours updated. Devices will receive the new schedule via config sync.',
        validationTimesRequired: 'Please enter both open and close times for {day}.',
        validationTimeFormat: 'Times must be in HH:mm format for {day}.',
        confirmTitle: 'Update operating hours?',
        confirmDesc: "You are about to update this location's operating hours and push the new schedule to the connected device. Whitelist overrides will still bypass these hours.",
        cancelBtn: 'Cancel',
        confirmBtn: 'Confirm & Push',
      },
    },
    commands: {
      updateBlocked: 'Remote update unavailable — this device runs edge software older than v{min}',
      updateBlockedCurrentVersion: ' (currently v{version})',
      statusPending: 'Queued',
      statusSent: 'Sent',
      pendingExpectation:
        'Runs on the device’s next heartbeat (usually within a minute) — no action needed.',
      sentExpectation:
        'The device received the command and is working on it. The status updates automatically.',
      sentUpdateExpectation:
        'The device received the command and is installing the update — this can take a few minutes. The status updates automatically.',
      delayedHint:
        'Taking longer than usual — the device may be offline or busy. Use the Refresh button in the top bar to check the latest status.',
      statusExecuted: 'Executed',
      statusFailed: 'Failed',
      statusCancelled: 'Cancelled',
      diagStatusCompletedHealthy: 'Completed · Healthy',
      diagStatusCompletedAttention: 'Completed · Attention needed',
      diagStatusCompletedCritical: 'Completed · Action required',
      diagStatusCompletedIncomplete: 'Completed · Not fully checked',
      executionLog: 'Execution log',
      executionLogVersionLabel: ' · edge v{version}',
      copyLog: 'Copy log',
      copied: 'Copied',
      logTruncated: 'Log truncated — the device produced more output than could be sent.',
      logTooLarge: 'The device sent an execution log too large to store.',
      logDropped: 'The device sent a malformed execution log — it could not be stored.',
      outputDropped: 'output dropped to fit the size limit',
      appliedVersionLabel: 'applied_version: {version}',
      historyEmpty: 'No commands have been sent to this device.',
      deviceLabel: 'Device: {name}',
      githubAccessHint:
        'GitHub credentials may be missing on this device. Run setup_github_access.sh once over SSH, then retry the update.',
      githubAccessDocsLink: 'GitHub access docs',
      diagOverallHealthy: 'Healthy',
      diagOverallAttention: 'Attention needed',
      diagOverallCritical: 'Action required',
      diagOverallIncomplete: 'Report incomplete',
      diagCountsSummary: '{passed} checks passed · {attention} need attention',
      diagCountsSummaryWithUnavailable:
        '{passed} checks passed · {attention} need attention · {unavailable} not checked',
      diagCopyReport: 'Copy report',
      diagViewChecks: 'View all checks',
      diagHideChecks: 'Hide all checks',
      diagNextStep: 'Next step:',
      diagLegacyTitle: 'Report unavailable',
      diagLegacyBody:
        'Command completed, but this software version did not return a diagnostic report. Update the edge software to enable self-test results.',
      diagDroppedTitle: 'Report unreadable',
      diagDroppedBody:
        'Self-test completed, but the diagnostic report format could not be read. Update edge software or contact support if this repeats.',
      diagTruncatedTitle: 'Report too large',
      diagTruncatedBody:
        'Self-test completed, but the device sent more diagnostic detail than could be stored. Update edge software if this repeats.',
      diagUnavailableTitle: 'Not fully checked',
      diagCheckClock: 'Clock / time sync',
      diagCheckDisk: 'Disk space',
      diagCheckMemory: 'Memory',
      diagCheckConfig: 'Configuration',
      diagCheckUploadQueue: 'Upload queue',
      diagCheckDeadLetters: 'Rejected logs',
      diagCheckRelay: 'Door relay',
      diagCheckUnknown: 'Check: {id}',
      diagReasonUnknown: 'Finding code: {reason}',
      diagReason: {
        clock_ok: 'System clock looks correct and synchronized.',
        clock_year_ok_sync_unknown:
          'System clock year looks correct. Sync status could not be confirmed on this device.',
        clock_year_invalid:
          'System clock is wrong. TLS and audit timestamps will be unreliable.',
        clock_not_synchronized: 'System clock is not synchronized with a time server.',
        disk_ok: 'Disk space is healthy ({pct}% used).',
        disk_low: 'Disk space is getting low ({pct}% used).',
        disk_critical: 'Disk space is critically low ({pct}% used).',
        disk_stat_unavailable: 'Disk usage could not be measured on this device.',
        memory_ok: 'Available memory is healthy ({mb} MB free).',
        memory_low: 'Available memory is low ({mb} MB free).',
        memory_critical: 'Available memory is critically low ({mb} MB free).',
        memory_stat_unavailable: 'Memory usage could not be measured on this device.',
        config_ok: 'Runtime configuration is readable.',
        config_missing: 'Runtime configuration is missing or unreadable.',
        config_cloud_missing: 'Cloud configuration section is missing.',
        config_heartbeat_missing: 'Heartbeat interval is not set in configuration.',
        upload_queue_ok: 'Upload queue is healthy ({count} pending).',
        upload_queue_stalled:
          '{count} access logs are waiting to upload and appear stalled.',
        upload_queue_unavailable: 'Upload queue database could not be opened.',
        dead_letters_ok: 'No permanently rejected logs are stored on the device.',
        dead_letters_present:
          '{count} logs were permanently rejected and need inspection.',
        dead_letters_unavailable: 'Rejected-log storage could not be checked.',
        relay_connected: 'Door relay hardware is connected.',
        relay_disconnected: 'Door relay hardware was not detected.',
        relay_mock_mode:
          'Relay check skipped — this device is running without USB hardware (development/mock mode).',
        relay_probe_unavailable: 'Relay check was not available on this run.',
        relay_probe_failed: 'Relay probe failed unexpectedly.',
        check_crashed: 'This check crashed and could not complete.',
      },
      diagAction: {
        clock_year_invalid:
          'Check network access for time sync (NTP), then reboot the device.',
        clock_not_synchronized:
          'Verify the store network allows NTP, then reboot if needed.',
        disk_low:
          'Ask support to free disk space on the device before it becomes critical.',
        disk_critical:
          'Contact support immediately — the device may stop logging or updating.',
        memory_low: 'Reboot the device if it becomes slow or unresponsive.',
        memory_critical:
          'Reboot the device now. Contact support if this keeps happening.',
        config_missing:
          'Contact support — the device may need its configuration restored.',
        config_cloud_missing:
          'Contact support — cloud sync settings may be incomplete.',
        config_heartbeat_missing:
          'Push a config update from the dashboard, or contact support.',
        upload_queue_stalled:
          'Check store internet. If the device is Online, try a reboot; contact support if the backlog remains.',
        upload_queue_unavailable:
          'Contact support — local log storage may be damaged.',
        dead_letters_present:
          'Contact support to inspect dead-letter logs on the device.',
        relay_disconnected:
          'Check the USB relay cable at the store. Contact support if it is plugged in.',
        relay_probe_failed:
          'Contact support — the USB/HID layer may need attention.',
        check_crashed: 'Re-run the self-test. Contact support if it keeps failing.',
      },
      // Remote command panel
      panelTitle: 'Remote Commands',
      panelDesc: 'Trigger remote actions on this device. Commands are delivered on the next heartbeat.',
      restartDevice: 'Restart Device',
      runDiagnostics: 'Run Diagnostics',
      enqueuing: 'Enqueuing…',
      enqueueSuccess: 'Command {command} enqueued successfully.',
      updateConfigNote: 'Note: UPDATE_CONFIG commands are enqueued automatically when saving configuration changes.',
      // Command history table
      historyNoCommands: 'No commands found.',
      historyColCreated: 'Created',
      historyColCommand: 'Command',
      historyColStatus: 'Status',
      historyColSent: 'Sent',
      historyColExecuted: 'Executed',
      historyColError: 'Error',
      statusAcked: 'Acknowledged',
    },
    maintenance: {
      edgeVersion: 'Edge v{version}',
      edgeVersionUnknown: 'Edge version unknown',
      heartbeatHint: 'Commands run on the next device heartbeat.',
      journeyLabel: 'Maintenance flow',
      journeyDiagnoseTitle: '1. Diagnose',
      journeyDiagnoseBody: 'Run Self-Test first to separate device issues from network or setup issues.',
      journeyInterveneTitle: '2. Intervene',
      journeyInterveneBody: 'Use reboot or software update only when the result points to that action.',
      journeyVerifyTitle: '3. Verify',
      journeyVerifyBody: 'Check Command History for the result, then run Self-Test again after changes.',
      enqueueFailed: 'Failed to enqueue command',
      unknownError: 'Unknown error',
      queueing: 'Queueing…',
      sendAgain: 'Send again',
      cancel: 'Cancel',
      diagnosticsTitle: 'Diagnostics',
      diagnosticsDesc:
        'Runs a remote self-test on the device. Results appear in Command History below. Does not reboot or change software.',
      runSelfTest: 'Run Self-Test',
      diagnosticsQueued: 'Self-test queued — runs on the next heartbeat cycle.',
      deviceControlTitle: 'Device Control',
      rebootDesc: 'Reboots the edge controller. The door will be briefly offline until the device comes back.',
      rebootWhenTitle: 'When a reboot helps',
      rebootWhen1: 'The door scanner stops reading QR codes even though the device shows Online.',
      rebootWhen2: 'The device shows Online but has stopped responding to recent commands.',
      rebootWhen3: 'The store internet or router was changed and the device has not reconnected on its own.',
      rebootBeforeTitle: 'Before you reboot',
      rebootBefore1: 'Run the Self-Test above first — it often finds the problem without taking the door offline.',
      rebootBefore2: 'If the device shows Offline, a remote reboot cannot reach it. Check power and internet at the store instead.',
      rebootBefore3: 'If everything is working, there is no need for routine reboots.',
      rebootDevice: 'Reboot Device',
      rebootConfirmPrompt: 'To confirm, type the store name "{name}" or "RESTART":',
      typeToConfirm: 'Type to confirm…',
      confirmRestart: 'Confirm Restart',
      restartQueued: 'Restart queued — device will reboot on the next heartbeat cycle.',
      updateTitle: 'Edge Software Update',
      updateDesc:
        'Assigns a release target to this device. The edge applies it on the next heartbeat via git, then restarts briefly.',
      currentVersion: 'Current version: v{version}',
      recommendedVersion: 'Latest release: v{version}',
      recommendedDetecting: 'Detecting latest release tag…',
      recommendedUnavailable: 'Could not detect the latest release tag',
      updateTargetUnset: '(set a release target)',
      updateSoftware: 'Update Edge Software',
      upToDateBadge: 'Up to date',
      upToDateHint: 'This device is running the latest release (v{version}). No update needed.',
      updateAvailableBadge: 'Update available: v{version}',
      updateAnyway: 'Re-install or choose another target',
      updateConfirmTitle: 'Confirm software update',
      updateGithubPrereq:
        'Git-v1 OTA needs on-device GitHub read access (configured once over SSH). Credentials stay on the device — never in this request.',
      updateGithubDocsLink: 'Open GitHub access setup docs',
      updateGithubCheckbox: 'This device has GitHub access configured',
      updateTargetLabel: 'Release target',
      updateAdvancedReveal: 'Need an unreleased build?',
      updateAdvancedWarningTitle: 'Not recommended for production',
      updateAdvancedWarningBody:
        'Tracking origin/main installs unreleased commits without a tagged release. Prefer a release tag unless you are testing a fix that has not shipped yet.',
      updateTrackLatest: 'I understand — track origin/main (latest)',
      updateAdvancedHide: 'Use a release tag instead',
      updateConsequenceTarget: 'Device will checkout {target} and restart the edge service.',
      updateConsequenceOffline: 'Door access may be briefly unavailable during the restart.',
      updateConsequenceHeartbeat: 'The command is delivered on the next heartbeat — not instantly.',
      updatePayloadSummary: 'Queued payload: target_version={target}',
      updateTargetLatestSummary: 'origin/main (latest)',
      confirmUpdate: 'Confirm Update',
      updateQueued: 'Update queued — device will apply it on the next heartbeat cycle.',
      qrSyncTitle: 'Bytekey QR Sync',
      qrSyncDesc: 'Capability and snapshot health reported by the edge heartbeat.',
      qrSyncReady: 'Ready',
      qrSyncNotReady: 'Not ready',
      qrSyncCapability: 'Capability',
      qrSyncStatus: 'Status',
      qrSyncSnapshotAge: 'Snapshot age',
      qrSyncValidUntil: 'Valid until',
      qrSyncMissing: 'missing',
      qrSyncUnknown: 'unknown',
      qrSyncAgeUnknown: 'unknown',
      qrSyncAgeSeconds: '{seconds}s',
      qrSyncAgeMinutes: '{minutes}m',
      qrSyncAgeHours: '{hours}h',
      qrSyncAgeDays: '{days}d',
      qrSyncGateReason: 'Rollout gate: {reason}',
      qrSyncLastError: 'Last error',
      historyTitle: 'Command History',
      historyDesc: 'Evidence of commands sent to this device and their outcomes.',
    },
    errors: {
      createOrganizationFailed: 'Failed to create organization',
    },
  },
  de: {
    common: {
      loading: 'Wird geladen...',
      settings: 'Einstellungen',
      profile: 'Profil',
      profileSettings: 'Profileinstellungen',
      signOut: 'Abmelden',
      play: 'Abspielen',
      openOnYouTube: 'Auf YouTube öffnen',
      userMenu: 'Benutzermenü',
      language: 'Sprache',
      switchTheme: 'Farbschema wechseln',
      themeUseDark: 'Dunkles Schema verwenden',
      themeUseLight: 'Helles Schema verwenden',
      themeUseSystem: 'Systemschema verwenden',
      english: 'Englisch',
      german: 'Deutsch',
      back: 'Zurück',
      noParentPage: 'Keine übergeordnete Seite',
      refresh: 'Aktualisieren',
      refreshed: 'Aktualisiert',
      loadingEllipsis: 'Wird geladen…',
      // Date/time picker
      time: 'Uhrzeit',
      clear: 'Löschen',
      apply: 'Übernehmen',
      selectTime: 'Zeit auswählen',
      done: 'Fertig',
      // Error boundary
      errorTitle: 'Etwas ist schiefgelaufen',
      errorMessage: 'Ein unerwarteter Fehler ist aufgetreten',
      tryAgain: 'Erneut versuchen',
      // Day names
      dayMonday: 'Montag',
      dayTuesday: 'Dienstag',
      dayWednesday: 'Mittwoch',
      dayThursday: 'Donnerstag',
      dayFriday: 'Freitag',
      daySaturday: 'Samstag',
      daySunday: 'Sonntag',
      // Common actions
      save: 'Speichern',
      cancel: 'Abbrechen',
      edit: 'Bearbeiten',
      copy: 'Kopieren',
      copied: 'Kopiert!',
      saving: 'Wird gespeichert...',
      unknownError: 'Unbekannter Fehler',
      anErrorOccurred: 'Ein Fehler ist aufgetreten',
    },
    auth: {
      signInTitle: 'Bei Ihrem Konto anmelden',
      signIn: 'Anmelden',
      signingIn: 'Anmeldung läuft...',
      email: 'E-Mail',
      password: 'Passwort',
      forgotPassword: 'Passwort vergessen?',
      forgotPasswordTitle: 'Passwort zurücksetzen',
      forgotPasswordHint: 'Geben Sie Ihre E-Mail-Adresse ein, und wir senden Ihnen einen Link zum Zurücksetzen.',
      sendResetLink: 'Link zum Zurücksetzen senden',
      sending: 'Wird gesendet...',
      backToSignIn: 'Zurück zur Anmeldung',
      resetEmailSentTitle: 'Prüfen Sie Ihr E-Mail-Postfach',
      resetEmailSentText: 'Wir haben einen Link zum Zurücksetzen gesendet an',
      resetEmailSentHint:
        'Klicken Sie auf den Link in der E-Mail, um Ihr Passwort zurückzusetzen. Der Link läuft in 1 Stunde ab.',
      signUpTitle: 'Konto erstellen',
      signUp: 'Registrieren',
      creatingAccount: 'Konto wird erstellt...',
      noAccount: 'Sie haben noch kein Konto?',
      haveAccount: 'Sie haben bereits ein Konto?',
      signUpLink: 'Registrieren',
      signInLink: 'Anmelden',
      checkEmail: 'Prüfen Sie Ihre E-Mails',
      emailConfirmationText: 'Wir haben Ihnen einen Bestätigungslink gesendet an',
      emailConfirmationHint: 'Bitte prüfen Sie Ihr Postfach, um den Registrierungsprozess abzuschließen.',
      returnToSignIn: 'Zurück zur Anmeldung',
      resetPasswordTitle: 'Neues Passwort festlegen',
      resetPasswordHint: 'Geben Sie unten Ihr neues Passwort ein.',
      newPassword: 'Neues Passwort',
      confirmPassword: 'Passwort bestätigen',
      updatePassword: 'Passwort aktualisieren',
      updating: 'Wird aktualisiert...',
      passwordMismatch: 'Die Passwörter stimmen nicht überein',
      passwordMinLength: 'Das Passwort muss mindestens 6 Zeichen lang sein',
      resetLinkExpired: 'Der Link zum Zurücksetzen ist abgelaufen. Bitte fordern Sie einen neuen an.',
      resetSuccess: 'Passwort erfolgreich zurückgesetzt! Bitte melden Sie sich mit dem neuen Passwort an.',
      genericError: 'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
      unexpectedError: 'Ein unerwarteter Fehler ist aufgetreten',
      emailRequiredError: 'E-Mail ist erforderlich',
      resetSendFailed: 'E-Mail zum Zurücksetzen konnte nicht gesendet werden',
      createPasswordPlaceholder: 'Passwort erstellen',
      enterPasswordPlaceholder: 'Passwort eingeben',
      enterNewPasswordPlaceholder: 'Neues Passwort eingeben',
      confirmNewPasswordPlaceholder: 'Neues Passwort bestätigen',
      passwordRule: 'Mindestens 6 Zeichen',
    },
    landing: {
      ctaPrimary: 'Komplettes Ecosystem ansehen',
      ctaSecondary: 'Zur Tür',
      ctaContact: 'HumanByte kontaktieren',
      ctaExisting: 'Bestehender Kunde? Dashboard öffnen',
      navSignUp: 'Registrieren',
      navLogin: 'Anmelden',
      navOpenDashboard: 'Dashboard öffnen',
      navLabel: 'Seitennavigation',
      navOpenMenu: 'Menü öffnen',
      navCloseMenu: 'Menü schließen',
      chapterRailLabel: 'Kapitel',
      trust1: 'Schweizer Rechtsgrundlage',
      trust2: 'Cloud- und Edge-Resilienz',
      trust3: 'Auditfähige Ereignisprotokolle',
      consoleRegion: 'Standorte',
      consoleDescription: 'Demonstration der Betreiberkonsole. Dies ist nicht das Live-Dashboard.',
      consoleUnlock: 'Entriegeln',
      consoleUnlockHint: 'Klicken, um die Tür zu öffnen',
      consoleUnlocking: 'Wird entriegelt…',
      consoleOpen: 'Geöffnet',
      consoleGranted: 'GEWÄHRT',
      consoleDenied: 'ABGELEHNT',
      consoleOperator: 'Betreiber',
      consoleRemoteReason: 'Fernentriegelung',
      consoleQrEntry: 'QR-Eintritt',
      consoleOutsideHours: 'Ausserhalb der Öffnungszeiten',
      phoneRegion: 'ByteKey',
      phoneDescription: 'Demonstration des Kunden-QR-Bildschirms. Dies ist nicht die Live-App.',
      phoneTitle: 'QR-Eingangscode',
      phoneHold: 'Auf den Code klicken',
      phoneScanning: 'Wird gescannt…',
      phoneGranted: 'Zutritt gewährt',
      phoneScanTitle: 'So scannen Sie',
      phoneScanText: 'Klicken Sie auf den Code. Die Tür liest ihn. Der Betreiber sieht den Durchgang.',
      phoneTabQr: 'QR-CODE',
      phoneTabAbout: 'ÜBER UNS',
      doorScanner: 'Türscanner',
      bytekeyProduct: 'ByteKey-Produktseite',
      storyKicker: 'Zwei Produkte. Ein Durchgang.',
      storyTitle: 'Ein Code. Eine Tür. Ein Protokoll.',
      beatKey: 'Der Schlüssel',
      beatDoor: 'Die Tür',
      beatOperator: 'Der Betreiber',
      recapKey:
        'ByteKey ist die iOS- und Android-App, mit der sich Kunden registrieren, ihre Identität verifizieren und einen QR-Zugangscode erhalten. Die Mitgliedschaft wird zum Code in der Tasche. App Store und Google Play — demnächst.',
      recapDoor:
        'ByteGate ist Edge-Hardware plus Cloud. Ein Scanner an jeder Tür entscheidet lokal, auch offline. Die Cloud hält Dashboard, Gerätestatus und Sentinel-Tagesprüfung.',
      recapOperator:
        'Jeder Durchgang landet in Standorte. Von hier aus entriegeln. Dasselbe Fenster, das der Betreiber den ganzen Tag nutzt.',
    },
    nav: {
      docs: 'Dokumentation',
      home: 'Dashboard-Startseite',
      primary: 'Hauptnavigation',
      tabLocations: 'Standorte',
      tabLogs: 'Protokolle',
      tabCustomers: 'Kunden',
      tabSentinel: 'Sentinel',
      tabMore: 'Mehr',
      moreHome: 'Dashboard-Startseite',
      closeMore: 'Menü schliessen',
    },
    legal: {
      privacy: 'Datenschutzerklärung',
      terms: 'Nutzungsbedingungen',
    },
    dashboard: {
      title: 'Dashboard',
      subtitle: 'Unten starten — oder die Tabs am unteren Bildschirmrand nutzen.',
      locations: 'Standorte',
      locationsDesc: 'Alle Standorte anzeigen und verwalten',
      addNewLocation: 'Neuen Standort hinzufügen',
      addNew: 'Neu',
      accessLogs: 'Zutrittsprotokolle',
      accessLogsDesc: 'Verlauf der Zutrittsprotokolle anzeigen',
      sentinel: 'Sentinel',
      sentinelDesc: 'Tägliche Überwachung und Prüfworkflow',
      customers: 'Kunden',
      customersDesc: 'Kunden suchen, Details ansehen und Newsletter-Listen exportieren',
    },
    customers: {
      title: 'Kunden',
      subtitle: 'Bytekey-Kunden dieser Organisation, alle paar Minuten synchronisiert.',
      search: 'Suche',
      filters: 'Filter',
      searchPlaceholder: 'Name, E-Mail, Telefon, Ort oder ID suchen',
      loading: 'Wird geladen…',
      updating: 'Kunden werden von Bytekey aktualisiert…',
      filterStatus: 'Status',
      statusAll: 'Alle Status',
      status_verified: 'Verifiziert',
      status_unverified: 'Nicht verifiziert',
      status_needs_recovery: 'Wiederherstellung nötig',
      status_disabled: 'Deaktiviert',
      status_rejected: 'Abgelehnt',
      filterNewsletter: 'Newsletter',
      newsletterAll: 'Alle',
      newsletterYes: 'Abonniert',
      newsletterNo: 'Nicht abonniert',
      registeredFrom: 'Registriert ab',
      registeredTo: 'Registriert bis',
      sort: 'Sortierung',
      sortName: 'Name',
      sortNewest: 'Neueste zuerst',
      colName: 'Name',
      colContact: 'Kontakt',
      colCity: 'Ort',
      colStatus: 'Status',
      colNewsletter: 'Newsletter',
      colRegistered: 'Registriert',
      total: '{n} Kunden',
      empty: 'Keine Kunden entsprechen diesen Filtern.',
      emptyNoData: 'Noch keine Kunden synchronisiert. Mit «Jetzt synchronisieren» von Bytekey laden.',
      notLinked: 'Diese Organisation ist noch mit keiner Bytekey-App verknüpft, daher können keine Kunden angezeigt werden.',
      loadFailed: 'Kunden konnten nicht geladen werden.',
      export: 'CSV exportieren',
      exportExcel: 'Für Excel exportieren',
      exportHint: 'Exportiert alle Kunden, die den aktuellen Filtern entsprechen.',
      sync: 'Jetzt synchronisieren',
      syncing: 'Synchronisiere…',
      syncFailed: 'Synchronisierung fehlgeschlagen. In einer Minute erneut versuchen.',
      lastSynced: 'Zuletzt synchronisiert {time}',
      neverSynced: 'Noch nicht synchronisiert',
      previous: 'Zurück',
      next: 'Weiter',
      pageInfo: '{from}–{to} von {total}',
      back: 'Alle Kunden',
      profile: 'Profil',
      firstName: 'Vorname',
      lastName: 'Nachname',
      email: 'E-Mail',
      telephone: 'Telefon',
      address: 'Adresse',
      heardAboutUs: 'Aufmerksam geworden durch',
      newsletter: 'Newsletter',
      status: 'Status',
      registeredAt: 'Registriert',
      phoneVerifiedAt: 'Telefon verifiziert',
      pendingDeletionAt: 'Löschung beantragt',
      customerId: 'Kunden-ID',
      yes: 'Ja',
      no: 'Nein',
      none: '—',
      access: 'Zutritt',
      blocked: 'Gesperrt',
      blockedSince: 'Gesperrt seit {time}',
      notBlocked: 'Nicht gesperrt',
      whitelisted: 'Auf der Whitelist',
      notWhitelisted: 'Nicht auf der Whitelist',
      block: 'An allen Standorten sperren',
      whitelist: 'An allen Standorten auf die Whitelist',
      reasonPrompt: 'Grund (optional)',
      actionDone: 'Gespeichert.',
      actionForbidden: 'Ihre Rolle darf das nicht.',
      actionFailed: 'Die Änderung konnte nicht gespeichert werden.',
      manageInSettings: 'Sperren und Whitelist in den Einstellungen verwalten',
      recentVisits: 'Letzte Besuche',
      noVisits: 'Keine Besuche an Ihren Standorten erfasst.',
      visitTime: 'Zeit',
      visitLocation: 'Standort',
      visitResult: 'Ergebnis',
      viewAllLogs: 'Alle Zutrittsprotokolle dieses Kunden',
      notFound: 'Kunde in dieser Organisation nicht gefunden.',
      bytekeyWhitelisted: 'In Bytekey auf der Whitelist',
    },
    storesList: {
      devices: '{n} Geräte',
      devicesOne: '1 Gerät',
      online: '{n} online',
      offline: '{n} offline',
      updateAvailable: '{n} Update verfügbar',
      updateAvailablePlural: '{n} Updates verfügbar',
      allUpToDate: 'Alle aktuell',
      statusOnline: 'Online',
      statusOffline: 'Offline',
      statusProvisioning: 'Wird eingerichtet',
      statusError: 'Fehler',
      lastSeen: 'Zuletzt: {time}',
      justNow: 'Gerade eben',
      minutesAgo: 'vor {n} Min.',
      hoursAgo: 'vor {n} Std.',
      daysAgo: 'vor {n} T.',
      never: 'Nie',
      ntpUnsynced: 'NTP nicht synchron',
      empty: 'Keine Standorte gefunden. Legen Sie Ihren ersten Standort an.',
      cpu: 'CPU',
      mem: 'RAM',
    },
    storeDetail: {
      restart: {
        checking: "Neustartstatus wird geprüft…",
        stateUnavailable: "Der Neustartstatus ist nicht verfügbar. Prüfen Sie den Status, bevor Sie es erneut versuchen.",
        refresh: "Neustartstatus prüfen",
        checkAgain: "Das Gerät hat noch kein endgültiges Ergebnis gemeldet. Prüfen Sie den Status, bevor Sie eine weitere Aktion ausführen.",
        inProgress: "Neustart läuft. Die Bestätigung des Geräts steht noch aus.",
        acknowledged: "Das Gerät hat den Neustart bestätigt. Es kann einen Moment dauern, bis es wieder verbunden ist.",
        completed: "Das Gerät hat den abgeschlossenen Neustart gemeldet.",
        commandFailed: "Der Neustart konnte nicht abgeschlossen werden. Prüfen Sie die Geräteverbindung, bevor Sie es nach der Wartezeit erneut versuchen.",
        cancelled: "Der Neustart wurde abgebrochen. Prüfen Sie die Geräteverbindung, bevor Sie es nach der Wartezeit erneut versuchen.",
        button: "Gerät neu starten",
        confirm: "Gerät am Standort {name} neu starten? Die Zutrittskontrolle kann kurz unterbrochen werden.",
        pending: "Neustart wird angefordert…",
        cooldown: "Kürzlich wurde ein Neustart angefordert. Versuchen Sie es in {seconds} Sekunden erneut.",
        cooldownUnknown: "Kürzlich wurde ein Neustart angefordert. Bitte warten Sie, bevor Sie es erneut versuchen.",
        forbidden: "Sie sind nicht berechtigt, dieses Gerät neu zu starten.",
        failed: "Neustart konnte nicht angefordert werden. Bitte versuchen Sie es erneut.",
        requested: "Neustart angefordert. Es kann einen Moment dauern, bis das Gerät wieder verbunden ist.",
      },

      tabsAria: 'Standort-Tabs',
      tabOverview: 'Übersicht',
      tabLogs: 'Zutrittsprotokolle',
      tabConfig: 'Konfiguration',
      tabMaintenance: 'Wartung',
      copyStoreId: 'Standort-ID kopieren',
      storeIdCopied: 'Standort-ID kopiert',
      configStatus: 'Konfigurationsstatus:',
      configSynced: 'Konfiguration synchron',
      updatePending: 'Update ausstehend',
      syncRequirement: '(Edge-Software v{version}+ für Sync-Status erforderlich)',
      edgeSoftware: 'Edge-Software:',
      unknown: 'Unbekannt',
      systemHealth: 'Systemzustand',
      todaysTraffic: 'Heutiger Verkehr',
      totalAttempts: 'Gesamtversuche',
      granted: 'Gewährt',
      denied: 'Abgelehnt',
      uniqueCustomers: 'Eindeutige Kunden',
      recentEvents: 'Letzte Ereignisse',
      noRecentEvents: 'Keine aktuellen Ereignisse',
      noRecentEventsDesc:
        'Keine aktuellen Ereignisse. Ereignisse erscheinen hier nach Zutrittsversuchen.',
      eventAccessAt: 'Benutzer {customer}: Zugang {result} um {time}',
      deviceSettings: 'Geräteeinstellungen',
      deviceSetup: 'Geräteeinrichtung',
      accessLogsDesc: 'Klicken Sie auf eine Protokollzeile, um alle Details anzuzeigen.',
      deniedOnly: 'Nur abgelehnte Zutritte',
      colTime: 'Zeit',
      colCustomerId: 'Kunden-ID',
      colCustomer: 'Kunde',
      colResult: 'Ergebnis',
      colIssueType: 'Problemtyp',
      rawJson: 'JSON-Rohdaten',
      noAccessLogs: 'Keine Zutrittsprotokolle gefunden.',
      noDeniedAccessLogs: 'Keine abgelehnten Zutritte gefunden.',
      notAvailable: 'k. A.',
      resultGranted: 'Gewährt',
      resultDenied: 'Abgelehnt',
      resultError: 'Fehler',
      cpuUsage: 'CPU-Auslastung',
      memoryUsage: 'Speicherauslastung',
      diskUsage: 'Festplattenauslastung',
      ntpStatus: 'NTP-Status',
      ntpSynced: 'Synchron',
      ntpUnsynced: 'Nicht synchron',
      lastCheck: 'Letzte Prüfung:',
      heartbeatInterval: 'Heartbeat-Intervall (Sekunden)',
      unlockDuration: 'Entriegelungsdauer (Sekunden)',
      savePush: 'Speichern & an Gerät senden',
      saving: 'Wird gespeichert…',
      saveSuccess: 'Konfiguration gespeichert und an das Gerät gesendet.',
      saveFailed: 'Konfiguration konnte nicht gespeichert werden.',
      invalidHeartbeat: 'Das Heartbeat-Intervall muss mindestens 30 Sekunden betragen.',
      invalidUnlock: 'Entriegelungsdauer muss eine positive Zahl sein.',
      heartbeatHint: 'Mindestens 30 Sekunden. Geräte senden in diesem Intervall einen Heartbeat.',
      storeIdLabel: 'Standort-ID',
      deviceSecret: 'Gerätegeheimnis',
      generateSecret: 'Neues Gerätegeheimnis erzeugen',
      generatingSecret: 'Wird erzeugt…',
      generateSecretHint:
        'Erzeugen Sie ein neues Geheimnis, wenn die Geräteanmeldedaten verloren oder kompromittiert wurden.',
      generateSecretFailed: 'Gerätegeheimnis konnte nicht erzeugt werden.',
      copy: 'Kopieren',
      secretWarning: 'Kopieren Sie dieses Geheimnis jetzt. Es wird nicht erneut angezeigt.',
      qrCode: 'QR-Code',
      qrCodeAlt: 'QR-Code des Gerätegeheimnisses',
      close: 'Schließen',
      editConfiguration: 'Konfiguration bearbeiten',
      configurationTitle: 'Konfiguration – {name}',
      latestConfigVersion: 'Aktuelle Konfigurationsversion: {version} (erstellt am {created})',
    },
    profile: {
      accountInformation: 'Kontoinformationen',
      emailNote: 'Ihre E-Mail-Adresse kann hier nicht geändert werden.',
      changePassword: 'Passwort ändern',
      currentPassword: 'Aktuelles Passwort',
      confirmNewPassword: 'Neues Passwort bestätigen',
      currentPasswordPlaceholder: 'Aktuelles Passwort eingeben',
      currentPasswordIncorrect: 'Das aktuelle Passwort ist falsch',
      updateFailed: 'Passwort konnte nicht aktualisiert werden',
      updateSuccess: 'Passwort erfolgreich aktualisiert',
    },
    settings: {
      organizationSettings: 'Organisationseinstellungen',
      organizationSettingsDesc: 'Verwalten Sie Ihre Organisationseinstellungen und Teammitglieder',
      tabGeneral: 'Allgemein',
      tabTeam: 'Team',
      tabWhitelist: 'Whitelist',
      tabBlocked: 'Gesperrte Kunden',
      tabSentinel: 'Sentinel',
      loadLocationsFailed: 'Standorte konnten nicht geladen werden',
      sentinelPageTitle: 'Sentinel-Konfiguration',
      sentinelPageIntro:
        'PepperShop-Terminals, Erkennungsschwellen und tägliche Zusammenfassungen für Sentinel konfigurieren.',
      sentinelNoLocations: 'Keine Standorte gefunden. Legen Sie zuerst einen Standort an, um Sentinel zu konfigurieren.',
      noOrganizationSelected: 'Keine Organisation ausgewählt',
      loadOrganizationFailed: 'Organisationsdetails konnten nicht geladen werden',
      organizationName: 'Organisationsname',
      organizationNamePlaceholder: 'Organisationsname eingeben',
      organizationNameUpdated: 'Organisationsname erfolgreich aktualisiert',
      organizationNameEmpty: 'Organisationsname darf nicht leer sein',
      organizationNameTooLong: 'Organisationsname darf höchstens 200 Zeichen lang sein',
      organizationNameUpdateFailed: 'Organisationsname konnte nicht aktualisiert werden',
      clientIdLabel: 'Client-ID',
      clientIdShareHint:
        'Teilen Sie diese ID nur mit vertrauenswürdigen Teammitgliedern, damit diese Zugang zu Ihrer Organisation anfordern können.',
      inviteEmailPlaceholder: 'benutzer@example.com',
      switchClient: 'Organisation wechseln',
      newOrganization: 'Neue Organisation',
      inviteEmail: 'E-Mail-Adresse',
      inviteRole: 'Rolle',
      roleManager: 'Manager',
      roleFae: 'FAE',
      roleAdmin: 'Admin',
      sendInvitation: 'Einladung senden',
      sendingInvitation: 'Wird gesendet...',
      inviteSuccess: 'Einladung erfolgreich gesendet!',
      inviteFailed: 'Einladung konnte nicht gesendet werden',
      // General settings
      general: {
        orgNameLabel: 'Organisationsname',
        orgNamePlaceholder: 'Organisationsnamen eingeben',
        orgNameEmpty: 'Organisationsname darf nicht leer sein',
        orgNameTooLong: 'Organisationsname darf höchstens 200 Zeichen lang sein',
        updateFailed: 'Organisationsname konnte nicht aktualisiert werden',
        updateSuccess: 'Organisationsname erfolgreich aktualisiert',
      },
      // Team management
      tabRecipients: "Berichtsempfänger",
      recipients: {
        hint: "Berichtszeitplan und Empfänger-Chat verwalten. Für die Anbietereinrichtung wenden Sie sich an den HumanByte-Support.",
        enabled: "Geplante Berichte aktivieren",
        hour: "Zustellstunde (0–23)",
        timezone: "Zeitzone",
        chatId: "Telegram-Chat-ID des Empfängers",
        saved: "Berichtsempfänger gespeichert.",
        loadFailed: "Berichtsempfänger konnten nicht geladen werden.",
        saveFailed: "Berichtsempfänger konnten nicht gespeichert werden.",
      },
      roleStaff: "Staff",
      roleShortHints: {
        client_admin: "HumanByte-Support mit Vollzugriff auf die Organisation.",
        manager: "Diebstahlfälle prüfen, Kunden kontaktieren und Staff verwalten.",
        fae: "Geräte installieren und warten; keine Kundendaten.",
        staff: "Tägliche Alarmprüfung und Neustarts. Kundendaten sichtbar.",
      },
      roleHints: {
        client_admin: "HumanByte-Support. Vollzugriff; kein Platz erforderlich.",
        manager: "Diebstahlentscheidungen, Kundenkontakte und Teameinladungen. Kann Staff entfernen; keine Geräteeinrichtung.",
        fae: "Geräteinstallation und technische Einstellungen. Keine Kundendaten oder Sentinel-Prüfung.",
        staff: "Tägliche Alarmprüfung und Neustarts. Sieht Kundendaten; kann Diebstahl nicht bestätigen oder Einstellungen ändern.",
      },
      team: {
        seatSummary: "{used} von {limit} Plätzen belegt",
        seatFree: "{free} frei",
        seatDetails: "Platzdetails",
        compareRoles: "Rollen vergleichen",
        rolePermissions: "Rollenberechtigungen",
        deliveryRetry: "E-Mail nicht gesendet. E-Mail-Zustellung erneut versuchen.",
        deliveryWaiting: "E-Mail wird gesendet. Prüfen Sie in Kürze erneut.",
        deliveryReplace: "Neue Einladung erforderlich. Widerrufen Sie diese Reservierung und laden Sie erneut ein.",
        deliveryContact: "Bitten Sie den Absender oder einen Admin, diese Einladung wiederherzustellen.",
        deliverySent: "E-Mail gesendet; Beitritt ausstehend.",
        invitationNoLongerPending: "Diese Einladung ist nicht mehr ausstehend. Prüfen Sie den aktuellen Zugriff in der Teamliste.",
        seatActiveOne: "{count} aktives Mitglied",
        seatActiveOther: "{count} aktive Mitglieder",
        seatPendingOne: "{count} ausstehende Einladung",
        seatPendingOther: "{count} ausstehende Einladungen",
        managerUnavailableOne: "Limit erreicht ({count} ausstehende Einladung)",
        managerUnavailableOther: "Limit erreicht ({count} ausstehende Einladungen)",
        seatsUnavailable: "Keine freien Plätze",
        seatAdmins: "Der HumanByte-Support belegt keinen Platz.",
        verifiedAdmin: "Admin — HumanByte-Support",
        legacyAdmin: "Admin (Altbestand) — Prüfung erforderlich",
        seatUnverified: "Mitgezählte Admin-Zuweisungen aus dem Altbestand: {count}. Identitätsprüfung erforderlich.",
        deliveryPending: "Einladung reserviert; E-Mail-Zustellung steht aus.",
        retryDelivery: "E-Mail-Zustellung erneut versuchen",
        deliveryFailed: "E-Mail-Zustellung konnte nicht erneut versucht werden.",
        errors: {
          INVITATION_EXPIRED: "Diese Einladung ist abgelaufen. Bitten Sie Ihren Team-Manager um eine neue Einladung.",
          INVITATION_REVOKED: "Diese Einladung wurde widerrufen.",
          INVITATION_ALREADY_ACCEPTED: "Diese Einladung wurde bereits angenommen.",
          EMAIL_MISMATCH: "Melden Sie sich mit der E-Mail-Adresse an, an die diese Einladung gesendet wurde.",
          RECIPIENT_MISMATCH: "Melden Sie sich mit der E-Mail-Adresse an, an die diese Einladung gesendet wurde.",
          NOT_FOUND: "Das angeforderte Element wurde nicht gefunden oder ist nicht zugänglich.",
          FORBIDDEN: "Sie sind nicht berechtigt, diese Aktion auszuführen.",
          INVALID_INPUT: "Prüfen Sie die übermittelten Organisationsangaben.",
          REQUEST_NOT_PENDING: "Diese Beitrittsanfrage wurde bereits bearbeitet.",
          DELIVERY_RATE_LIMITED: "Bitte warten Sie, bevor Sie diese Einladung erneut zustellen.",
          INVALID_ROLE: "Wählen Sie eine gültige Rolle.",
          INVALID_EMAIL: "Eine gültige E-Mail-Adresse ist erforderlich.",
          INVALID_NAME: "Ein Organisationsname ist erforderlich.",
          ORGANIZATION_OPERATION_FAILED: "Die Organisation konnte nicht aktualisiert werden. Bitte versuchen Sie es erneut.",
          REBOOT_COOLDOWN: "Kürzlich wurde ein Neustart angefordert. Versuchen Sie es in {seconds} Sekunden erneut.",
          REVIEW_TRANSITION_NOT_ALLOWED: "Nur ein Manager oder HumanByte-Admin kann diese Diebstahlentscheidung ändern.",
          ROLE_NOT_ALLOWED_INVITE: "Ihre Rolle kann diese Rolle nicht einladen.",
          ROLE_NOT_ALLOWED_APPROVE: "Ihre Rolle kann eine Anfrage mit dieser Rolle nicht genehmigen.",
          ROLE_NOT_ALLOWED_REVOKE: "Ihre Rolle kann diese Einladung nicht widerrufen.",
          ROLE_NOT_ALLOWED_CHANGE: "Ihre Rolle kann die Rolle dieses Mitglieds nicht ändern.",
          ROLE_NOT_ALLOWED_REMOVE: "Ihre Rolle kann dieses Mitglied nicht entfernen.",

          SEAT_LIMIT_REACHED: "Alle 5 Plätze sind belegt, einschliesslich ausstehender Einladungen. Entfernen Sie ein Mitglied oder widerrufen Sie eine Einladung.",
          MANAGER_LIMIT_REACHED: "Beide Manager-Positionen sind belegt, einschliesslich ausstehender Manager-Einladungen.",
          LAST_MANAGER_REQUIRED: "Der letzte aktive Manager kann nicht entfernt werden oder eine andere Rolle erhalten.",
          ROLE_NOT_ALLOWED: "Ihre Rolle erlaubt diese Teamaktion nicht.",
          INVITATION_ALREADY_EXISTS: "Für diese Person besteht bereits eine ausstehende Einladung für diese Organisation.",
          MEMBER_ALREADY_EXISTS: "Diese Person gehört bereits zu dieser Organisation.",
          INVITATION_ROLE_CONFLICT: "Eine ausstehende Einladung weist eine andere Rolle zu. Widerrufen Sie sie, bevor Sie diese Anfrage genehmigen.",
          HUMANBYTE_ADMIN_REQUIRED: "Admin-Zugriff kann nur einem verifizierten HumanByte-Supportkonto zugewiesen werden.",
          STAFF_NOT_ENABLED: "Staff-Zugriff ist für diese Organisation noch nicht aktiviert.",
        },

        loadMembersFailed: 'Mitglieder konnten nicht geladen werden',
        loadInvitationsFailed: 'Einladungen konnten nicht geladen werden',
        loadRequestsFailed: 'Beitrittsanfragen konnten nicht geladen werden',
        loadFailed: 'Daten konnten nicht geladen werden',
        inviteMembers: 'Mitglieder einladen',
        activeMembers: 'Aktive Mitglieder',
        pendingInvitations: 'Ausstehende Einladungen',
        joinRequests: 'Beitrittsanfragen',
        noPendingInvitations: 'Keine ausstehenden Einladungen',
        noPendingJoinRequests: 'Keine ausstehenden Beitrittsanfragen',
        noMembers: 'Noch keine Mitglieder',
        youLabel: '(Sie)',
        joinedOn: 'Beigetreten am {date}',
        invitedOn: 'Eingeladen am {date}',
        requestedOn: 'Angefragt am {date}',
        memberActions: 'Mitgliederaktionen',
        changeRole: 'Rolle ändern',
        changeRoleFailed: 'Rolle konnte nicht geändert werden',
        removeMember: 'Mitglied entfernen',
        removing: 'Wird entfernt...',
        removeConfirm: 'Sind Sie sicher, dass Sie {email} entfernen möchten?',
        removeFailed: 'Mitglied konnte nicht entfernt werden',
        approve: 'Genehmigen',
        approving: 'Wird genehmigt...',
        approveFailed: 'Anfrage konnte nicht genehmigt werden',
        deny: 'Ablehnen',
        rejectConfirm: 'Sind Sie sicher, dass Sie diese Beitrittsanfrage ablehnen möchten?',
        rejectFailed: 'Anfrage konnte nicht abgelehnt werden',
        revoke: 'Zurückziehen',
        revokeConfirm: 'Sind Sie sicher, dass Sie diese Einladung zurückziehen möchten?',
        revokeFailed: 'Einladung konnte nicht zurückgezogen werden',
        selectRole: 'Rolle auswählen',
        saving: 'Wird gespeichert...',
      },
      // Blocked customers
      blocked: {
        loadFailed: 'Gesperrte Kunden konnten nicht geladen werden',
        addFailed: 'Gesperrter Kunde konnte nicht hinzugefügt werden',
        updateFailed: 'Gesperrter Kunde konnte nicht aktualisiert werden',
        unblockFailed: 'Entsperren des Kunden fehlgeschlagen',
        addSuccess: 'Gesperrter Kunde hinzugefügt. Geräte erhalten Updates über die Konfiguration.',
        updateSuccess: 'Gesperrter Kunde aktualisiert. Geräte erhalten Updates über die Konfiguration.',
        unblockSuccess: 'Kunde entsperrt. Geräte erhalten Updates über die Konfiguration.',
        customerIdRequired: 'Kunden-ID ist erforderlich',
        selectLocationError: 'Bitte wählen Sie einen Standort aus',
        copiedToClipboard: 'Kunden-ID in die Zwischenablage kopiert',
        copyFailed: 'Kopieren in die Zwischenablage fehlgeschlagen',
        unblockConfirm: 'Sind Sie sicher, dass Sie diesen Kunden entsperren möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
        title: 'Gesperrte Kunden',
        desc: 'Gesperrte Kunden in allen Standorten Ihrer Organisation verwalten',
        filterByLocation: 'Nach Standort filtern',
        filterAll: 'Alle',
        filterGlobalOnly: 'Nur globale',
        addTitle: 'Gesperrten Kunden hinzufügen',
        listTitle: 'Liste der gesperrten Kunden',
        noConfigured: 'Keine gesperrten Kunden konfiguriert.',
        noMatch: 'Keine gesperrten Kunden entsprechen dem aktuellen Filter.',
        colCustomerId: 'Kunden-ID',
        colLocationScope: 'Standort / Bereich',
        colScope: 'Bereich',
        colReason: 'Grund',
        colCreated: 'Erstellt',
        colExpires: 'Ablauf',
        colActions: 'Aktionen',
        labelCustomerId: 'Kunden-ID',
        labelReason: 'Grund (optional)',
        labelExpiresAt: 'Ablaufdatum (optional)',
        labelScope: 'Bereich',
        labelLocation: 'Standort',
        scopeLocation: 'Nur dieser Standort',
        scopeGlobal: 'Alle Standorte (organisationsweit)',
        scopeLocationSpecific: 'Standortspezifisch',
        scopeLocationOnly: 'Standortbegrenzt',
        scopeGlobalDisplay: 'Global',
        selectLocation: 'Standort auswählen',
        expiresAtPlaceholder: 'Ablaufdatum und Uhrzeit auswählen',
        addBtn: 'Gesperrten Kunden hinzufügen',
        adding: 'Wird hinzugefügt...',
        loading: 'Wird geladen…',
        editReason: 'Grund eingeben (optional)',
        expired: '(Abgelaufen)',
        saving: 'Wird gespeichert...',
        saveBtn: 'Speichern',
        cancelBtn: 'Abbrechen',
        editBtn: 'Bearbeiten',
        unblocking: 'Wird entsperrt...',
        unblockBtn: 'Entsperren',
        copyTooltip: 'Kunden-ID kopieren',
      },
      whitelist: {
        emptyNoLocations:
          'Für diese Organisation wurden keine Standorte gefunden. Legen Sie einen Standort an, um Whitelist-Einträge zu verwalten.',
        title: 'Whitelisted-Kunden',
        desc: 'Whitelisted-Kunden über alle Standorte Ihrer Organisation verwalten',
        filterByLocation: 'Nach Standort filtern',
        filterAll: 'Alle',
        filterGlobalOnly: 'Nur global',
        addTitle: 'Whitelisted-Kunden hinzufügen',
        listTitle: 'Whitelist-Kundenliste',
        noConfigured: 'Keine whitelisted Kunden konfiguriert.',
        noMatch: 'Keine whitelisted Kunden entsprechen dem aktuellen Filter.',
        colCustomerId: 'Kunden-ID',
        colLocationScope: 'Standort / Bereich',
        colReason: 'Grund',
        colCreated: 'Erstellt',
        colActions: 'Aktionen',
        labelCustomerId: 'Kunden-ID',
        labelReason: 'Grund (optional)',
        labelScope: 'Bereich',
        labelLocation: 'Standort',
        scopeGlobal: 'Alle Standorte (organisationsweit)',
        scopeLocationSpecific: 'Standortspezifisch',
        selectLocation: 'Standort auswählen',
        selectLocationError: 'Bitte wählen Sie einen Standort aus',
        customerIdRequired: 'Kunden-ID ist erforderlich',
        adding: 'Wird hinzugefügt...',
        addBtn: 'Whitelisted-Kunden hinzufügen',
        loading: 'Wird geladen…',
        editReasonPlaceholder: 'Grund eingeben (optional)',
        saving: 'Wird gespeichert...',
        saveBtn: 'Speichern',
        cancelBtn: 'Abbrechen',
        editBtn: 'Bearbeiten',
        removing: 'Wird entfernt...',
        removeBtn: 'Entfernen',
        removeConfirm:
          'Diesen Whitelist-Eintrag wirklich entfernen? Diese Aktion kann nicht rückgängig gemacht werden.',
        copyTooltip: 'Kunden-ID kopieren',
        copiedSuccess: 'Kunden-ID in die Zwischenablage kopiert',
        copyFailed: 'Kopieren in die Zwischenablage fehlgeschlagen',
        loadFailed: 'Whitelisted-Kunden konnten nicht geladen werden',
        addFailed: 'Whitelisted-Kunde konnte nicht hinzugefügt werden',
        updateFailed: 'Whitelisted-Kunde konnte nicht aktualisiert werden',
        removeFailed: 'Whitelisted-Kunde konnte nicht entfernt werden',
        addSuccess: 'Whitelisted-Kunde hinzugefügt. Geräte erhalten Overrides über die Konfiguration.',
        updateSuccess: 'Whitelisted-Kunde aktualisiert. Geräte erhalten Overrides über die Konfiguration.',
        removeSuccess: 'Whitelisted-Kunde entfernt. Geräte erhalten die aktualisierte Konfiguration beim nächsten Sync.',
        scopeGlobalDisplay: 'Global',
        // Service accounts
        serviceTitle: 'Servicekonto erstellen',
        serviceDesc: 'Erstellen Sie ein operatives Servicekonto für QR-basierten Zutritt. Servicekonto-IDs müssen den SVC-Namensraum verwenden.',
        serviceCsvGuidance: 'Wenn diese ID in PepperShop existieren muss, importieren Sie dort die CSV, bevor Sie den QR-Code verteilen. Der Türzutritt nutzt die bestehende Geräte-Whitelist-Synchronisierung, ein Edge-Firmware-Update ist nicht erforderlich.',
        serviceKundenNr: 'Kunden-Nr',
        serviceKundenNrPlaceholder: 'SVC-',
        serviceKundenNrHelp: 'Erforderliches Format: SVC- gefolgt von Buchstaben, Zahlen oder Bindestrichen.',
        serviceKundenNrRequired: 'Kunden-Nr ist erforderlich',
        serviceFirma: 'Firma',
        serviceVorname: 'Vorname',
        serviceNachname: 'Nachname',
        serviceCreating: 'Wird erstellt...',
        serviceCreateBtn: 'Servicekonto erstellen',
        serviceCreateFailed: 'Servicekonto konnte nicht erstellt werden',
        serviceCreateSuccess: 'Servicekonto erstellt. Laden Sie das QR-PNG oder die CSV für den operativen Einsatz herunter.',
        downloadQrPng: 'QR-PNG herunterladen',
        downloadCsv: 'CSV herunterladen',
        colDisplayName: 'Anzeigename',
        colType: 'Typ',
        typeServiceAccount: 'Servicekonto',
        typeCustomer: 'Kunde',
        qrBtn: 'QR',
        csvBtn: 'CSV',
      },
    },
    logs: {
      filtersUnavailable: 'Standort- und Zeitzoneneinstellungen sind nicht verfügbar. Vor dem Ändern der Untersuchungsfilter erneut versuchen.',
      unappliedFilters: 'Änderungen nicht angewendet. Die Ergebnisse unten verwenden weiterhin Ihre vorherigen Filter.',
      liveResults: "Live-Scanereignisse: Neue Einträge können Seiten und Summen verändern. Zum Neuladen aktualisieren.",
      investigationTimezone: "Zeitzone der Untersuchung",
      fromRepeatedTime: 'Wiederholte Von-Uhrzeit',
      toRepeatedTime: 'Wiederholte Bis-Uhrzeit',
      repeatedTimeHint: '{civil} kommt in {timezone} zweimal vor. Wählen Sie die gemeinte Uhrzeit.',
      beforeClocksMoveBack: '{time} — vor der Zeitumstellung ({offset})',
      afterClocksMoveBack: '{time} — nach der Zeitumstellung ({offset})',
      invalidTimezone: 'Geben Sie eine gültige Zeitzone für die Untersuchung ein.',
      malformedBound: 'Geben Sie {field} als YYYY-MM-DDTHH:mm ein oder verwenden Sie die Kalenderschaltfläche.',
      nonexistentBound: 'Diese {field}-Uhrzeit existiert in {timezone} wegen der Zeitumstellung nicht.',
      ambiguousBound: 'Wählen Sie, ob {field} vor oder nach der Zeitumstellung liegt.',
      reversedRange: 'Bis muss gleich oder nach Von liegen.',
      dateTimePlaceholder: 'Datum und Uhrzeit wählen',
      allLocations: 'Alle Standorte',
      allResults: 'Alle Ergebnisse',
      allIssueTypes: 'Alle Problemtypen',
      customerIdHelp: 'Stimmt mit der vollständigen Kunden-ID überein.',
      issueUserBlocked: 'Benutzer gesperrt',
      issueClockInvalid: 'Geräteuhr ungültig',
      issueWhitelistOverride: 'Whitelist-Ausnahme',
      issueOutOfHours: 'Außerhalb der Öffnungszeiten',
      issueUserNotFound: 'Benutzer nicht gefunden',
      issueOfflineMode: 'Offline-Modus',
      issueCacheMissOffline: 'Offline nicht zwischengespeichert',
      issueNetworkError: 'Netzwerkfehler',
      issueRelayFailure: 'Relaisfehler',
      issueSystemError: 'Systemfehler',
      issueBytekeySnapshotUnavailable: 'ByteKey-Snapshot nicht verfügbar',
      issueBytekeyLegacyOnly: 'Zutritt durch bisherige Validierung',
      loadFailed: "Ergebnisse nicht verfügbar. Bitte erneut versuchen.",
      fromOccurrence: "Von: Auftreten der wiederholten Stunde",
      toOccurrence: "Bis: Auftreten der wiederholten Stunde",
      chooseIfRepeated: "Bei wiederholter Stunde auswählen",
      earlierOccurrence: "Erstes Auftreten",
      laterOccurrence: "Zweites Auftreten",
      chooseDateTime: 'Auswählen:',
      dateAndTime: 'Datum und Uhrzeit',
      pickerHour: 'Stunde',
      pickerMinute: 'Minute',
      boundsHint: "Datum und Uhrzeit verwenden die Zeitzone der Untersuchung. Beide Grenzen sind eingeschlossen; 03:00 bedeutet genau 03:00:00.",
      timezoneConflict: "Konfigurierte und erkannte Standortzeitzonen unterscheiden sich. Die oben angegebene Untersuchungszeitzone bestimmt diese Suche.",
      invalidRange: "Zeitzone und Zeitraum prüfen. Eine übersprungene Uhrzeit ist ungültig; bei einer wiederholten Stunde das erste oder zweite Auftreten wählen.",
      applyFilters: "Filter anwenden",
      customInterval: "Zutrittsaktivität (ausgewählter Zeitraum)",
      overviewHint: "Aktuelle Übersicht; die ungefilterte Protokolltabelle kann einen anderen Zeitraum abdecken.",
      chartBothBounds: "Von und Bis auswählen, um den genauen Untersuchungszeitraum darzustellen.",
      summaryFailed: "Diagramm nicht verfügbar. Zeitraum und Auflösung prüfen oder erneut versuchen.",

      title: 'Zutrittsprotokolle',
      colorCoding:
        'Farbcodierung: Rote Zeilen = Hardware-/Netzwerkprobleme, Gelb = Benutzer-/Regelprobleme, Grünes Badge = erfolgreicher Zutritt.',
      refresh: 'Aktualisieren',
      location: 'Standort',
      result: 'Ergebnis',
      issueType: 'Problemtyp',
      from: 'Von',
      to: 'Bis',
      all: 'Alle',
      clearFilters: 'Filter zurücksetzen',
      startDate: 'Startdatum und Uhrzeit wählen',
      endDate: 'Enddatum und Uhrzeit wählen',
      tabLogs: 'Protokolle',
      tabTrends: 'Trends',
      tabsAria: 'Protokollansicht',
      colTime: 'Zeit',
      colStore: 'Standort',
      colCustomerId: 'Kunden-ID',
      notAvailable: 'k. A.',
      unknownStore: 'Unbekannt',
      resultGranted: 'Gewährt',
      resultDenied: 'Abgelehnt',
      resultError: 'Fehler',
      noLogsFound: 'Keine Protokolle gefunden',
      chartTotal: 'Gesamt',
      // Access logs chart
      chartHourTitle: 'Zutrittsaktivität (letzte Stunde)',
      chartDayTitle: 'Zutrittsaktivität (letzte 24 Std.)',
      chartWeekTitle: 'Zutrittsaktivität (letzte 7 Tage)',
      chartMonthTitle: 'Zutrittsaktivität (letzte 30 Tage)',
      chartYearTitle: 'Zutrittsaktivität (letztes Jahr)',
      chartHourTooltip: 'Stundenansicht — letzte 60 Minuten',
      chartDayTooltip: 'Tagesansicht — letzte 24 Stunden',
      chartWeekTooltip: 'Wochenansicht — letzte 7 Tage',
      chartMonthTooltip: 'Monatsansicht — letzte 30 Tage',
      chartYearTooltip: 'Jahresansicht — letzte 12 Monate',
      chartGranHour: 'S',
      chartGranDay: 'T',
      chartGranWeek: 'W',
      chartGranMonth: 'M',
      chartGranYear: 'J',
      chartNow: 'jetzt',
      tzHint:
        'Bucket-Grenzen und Beschriftungen verwenden diese Zeitzone: die lokale Zeit des ausgewählten Standorts, die gemeinsame lokale Zeit Ihrer Standorte, wenn sie übereinstimmen, oder UTC, wenn sie mehrere Zonen umfassen.',
      noAccessEvents: 'Keine Zutrittsereignisse in diesem Zeitraum.',
    },
    onboarding: {
      setupOrganization: "Erstellen Sie Ihre Organisation und verwalten Sie Ihr Team.",
      completeTitle: "Ihre Organisation ist bereit",
      completeManagerHint: "Sie sind der erste Manager. Verwalten Sie jetzt Ihr Team; der HumanByte-Support oder ein FAE übernimmt die technische Geräteeinrichtung.",
      openTeam: "Teameinstellungen öffnen",

      welcome: 'Willkommen bei ByteGate',
      startChoice: 'Starten Sie mit dem Erstellen oder Beitreten einer Organisation',
      requestAccess: 'Zugriff auf eine Organisation anfordern',
      setupOrgLocation: 'Lassen Sie uns Ihre Organisation und den ersten Standort einrichten',
      organization: 'Organisation',
      firstLocation: 'Erster Standort',
      choosePath: 'Wählen Sie Ihren Weg',
      choosePathDesc: 'Erstellen Sie eine neue Organisation oder treten Sie einer bestehenden bei',
      createOrg: 'Neue Organisation erstellen',
      createOrgDesc: 'Starten Sie mit Ihrer eigenen Organisation und verwalten Sie Ihr Team',
      joinOrg: 'Bestehender Organisation beitreten',
      joinOrgDesc: 'Fordern Sie mit der Client-ID Zugriff auf eine Organisation an',
      businessName: 'Unternehmensname',
      businessPlaceholder: 'Acme Retail',
      businessHint: 'Dies wird Ihr Organisationsname in ByteGate',
      continue: 'Weiter',
      creating: 'Wird erstellt...',
      locationName: 'Standortname',
      locationPlaceholder: 'Filiale Hauptstraße',
      locationHint: 'Dies wird Ihr erster physischer Standort',
      createLocation: 'Standort erstellen',
      createLocationFailed: 'Standort konnte nicht erstellt werden',
      pendingInvitesTitle: 'Sie haben ausstehende Einladungen',
      pendingInvitesDesc:
        'Treten Sie einer Organisation bei, die Sie bereits eingeladen hat, oder fahren Sie mit einer neuen Einrichtung fort.',
      openInvitationEmail: "Öffne den Link in deiner Einladungs-E-Mail, um beizutreten.",
      invitedAs: 'Eingeladen als {role} an {email}',
      acceptInvite: 'Einladung annehmen',
      joinRequestSent: 'Beitrittsanfrage gesendet',
      joinRequestSentDesc:
        'Ihre Anfrage wartet auf die Prüfung durch den Organisationsadministrator. Prüfen Sie hier erneut, ob Sie Zugriff haben.',
      cancelRequestCreateOrg: 'Anfrage abbrechen & neue Organisation erstellen',
      cancelRequest: 'Anfrage zurückziehen',
      cancellingRequest: 'Wird zurückgezogen…',
      cancelRequestFailed: 'Ihre Anfrage konnte nicht zurückgezogen werden. Bitte versuchen Sie es erneut.',
      organizationClientId: 'Organisations-Client-ID',
      clientIdHint: 'Geben Sie die Client-ID ein, die Sie vom Organisationsadministrator erhalten haben',
      invalidClientId: 'Bitte geben Sie eine gültige Client-ID ein (UUID-Format)',
      joinRequestFailed: 'Beitrittsanfrage konnte nicht gesendet werden',
      sendRequest: 'Anfrage senden',
    },
    invite: {
      verifyingTitle: 'Einladung wird geprüft',
      verifyingHint: 'Bitte warten...',
      invalidTitle: 'Ungültige Einladung',
      alreadyAccepted: 'Diese Einladung wurde bereits angenommen.',
      expired: 'Diese Einladung ist abgelaufen. Bitte fordern Sie eine neue Einladung an.',
      invalid: 'Dieser Einladungslink ist ungültig oder existiert nicht mehr.',
      verifyFailed: 'Diese Einladung konnte nicht geprüft werden.',
      emailMismatchTitle: 'E-Mail stimmt nicht überein',
      emailMismatchHint: 'Bitte melden Sie sich ab und mit der E-Mail-Adresse an, die diese Einladung erhalten hat.',
      emailMismatchBody: "Diese Einladung ist für {invitedEmail}, aber Sie sind als {currentEmail} angemeldet.",
      signOutSwitch: 'Abmelden und Konto wechseln',
      invitedTitle: 'Sie wurden eingeladen!',
      invitedBody: 'hat Sie eingeladen beizutreten als',
      invitedHint: 'Erstellen Sie ein neues Konto oder melden Sie sich an mit',
      invitedHintEnd: ', um diese Einladung anzunehmen.',
      createAccountToAccept: 'Konto erstellen und annehmen',
      signInToAccept: 'Anmelden und annehmen',
      acceptTitle: 'Einladung annehmen',
      acceptCta: 'Einladung annehmen',
      accepting: 'Wird angenommen...',
      acceptFailed: 'Einladung konnte nicht angenommen werden',
      roleAdmin: 'Admin',
      roleFae: 'FAE',
      roleManager: 'Manager',
    },
    sentinel: {
      title: 'Sentinel',
      description: 'Tägliche Standortprüfung aus nächtlicher Analyse von Zutritten und POS-Zahlungen.',
      releaseGateHidden: 'Die tägliche Sentinel-Prüfung ist derzeit durch das Release-Gate ausgeblendet.',
      updateAlertFailed: 'Alarm konnte nicht aktualisiert werden',
      saveFailed: 'Speichern fehlgeschlagen.',
      testFailed: 'Test fehlgeschlagen.',
      // Status labels
      statusPending: 'Ausstehende Prüfung',
      statusFalseAlarm: 'Fehlalarm',
      statusConfirmedTheft: 'Bestätigter Diebstahl',
      statusSuspectedTheft: 'Diebstahlverdacht',
      statusAutoDismissed: 'Automatisch verworfen',
      // Sync health banner
      syncDegraded: '⚠️ PepperShop-Synchronisation gestört — Anomalieerkennung pausiert',
      lastSync: 'Letzte erfolgreiche Synchronisation:',
      neverSynced: 'Noch nie synchronisiert',
      consecutiveFailures: 'aufeinanderfolgende Fehler',
      // Alert list filters / table
      allLocations: 'Alle Standorte',
      alertFilterStatus: 'Status',
      alertFilterLocation: 'Standort',
      filterAll: 'Alle',
      noAlertsFound: 'Keine Alarme gefunden',
      noPendingAlerts: 'Keine ausstehenden Alarme — alle Aktivitäten erscheinen normal.',
      noFilteredAlerts: 'Keine Alarme entsprechen den aktuellen Filtern.',
      colEntryTime: 'Zutrittszeit',
      colLocation: 'Standort',
      colCustomer: 'Kunde',
      colStats: 'Statistiken',
      colStatus: 'Status',
      colAction: 'Aktion',
      reviewAction: 'Prüfen →',
      metricTileGap: 'Lücke',
      metricTileGapHint:
        'Bewilligte Zutritte minus POS-Bestellungen in diesem Zeitraum (mindestens 0). Eine Lücke ist normal — Browser, Retouren, Begleitpersonen. Steigt die Lücke gegenüber der Vorperiode, lohnt ein Blick.',
      metricTileEntries: 'Zutritte (bewilligt)',
      metricTileEntriesShort: 'Zutritte',
      metricTilePayments: 'Zahlungen',
      metricTileAlerts: 'Alarme',
      ownerTrendTooltipGap: 'Lücke (Zutritte − Zahlungen): {value}',
      ownerTrendTooltipUniqueCustomers: 'Eindeutige Kunden (bewilligt)',
      ownerTrendTooltipWhitelistOverride: 'Whitelist-Ausnahme: {count}',
      paymentsAttributionFallback:
        'Zahlungen zeigen alle Bestellungen der Organisation (Terminal-IDs in den Sentinel-Einstellungen verknüpfen zum Filtern).',
      alertsTooltipReviewHint: 'Roten Punkt anklicken zum Prüfen.',
      alertDotPopoverTitle: 'Alarme',
      alertDotViewAll: 'Alle {count} Alarme in diesem Zeitraum anzeigen',
      alertDotAriaLabel: '{count} Alarm(e) bei {label} öffnen',
      ownerTrendHourly: 'Aktivität (letzte Stunde)',
      ownerTrendDaily: 'Aktivität (letzte 24 Std.)',
      ownerTrendWeekly: 'Aktivität (letzte 7 Tage)',
      ownerTrendMonthly: 'Aktivität (letzte 30 Tage)',
      ownerTrendYearly: 'Aktivität (letzte 12 Monate)',
      ownerTrendHourlyTooltip: 'Stundenansicht — letzte 60 Minuten',
      ownerTrendDailyTooltip: 'Tagesansicht — letzte 24 Stunden',
      ownerTrendWeeklyTooltip: 'Wochenansicht — letzte 7 Tage',
      ownerTrendMonthlyTooltip: 'Monatsansicht — letzte 30 Tage',
      ownerTrendYearlyTooltip: 'Jahresansicht — letzte 12 Monate',
      alertTrendTzHint:
        'Grenzen und Beschriftungen der Buckets verwenden diese Zeitzone: lokale Zeit des gewählten Standorts, gemeinsame lokale Zeit Ihrer Standorte wenn alle übereinstimmen, oder UTC bei mehreren Zeitzonen.',
      alertTrendAnchorHint: 'Wählen Sie einen Tag, um den Trend bis zu diesem Datum anzuzeigen',
      alertTrendAnchorAria: 'Enddatum des Trends',
      alertTrendNow: 'Jetzt',
      noOwnerEventsHourly:
        'Keine Zutritte, Zahlungen oder Alarme in der letzten Stunde.',
      noOwnerEventsDaily:
        'Keine Zutritte, Zahlungen oder Alarme in den letzten 24 Stunden.',
      noOwnerEventsWeekly:
        'Keine Zutritte, Zahlungen oder Alarme in den letzten 7 Tagen.',
      noOwnerEventsMonthly:
        'Keine Zutritte, Zahlungen oder Alarme in den letzten 30 Tagen.',
      noOwnerEventsYearly:
        'Keine Zutritte, Zahlungen oder Alarme in den letzten 12 Monaten.',
      alerts: 'Alarme',
      // Alert detail — header & stats
      unknownLocation: 'Unbekannter Standort',
      entryDetectedAt: 'Zutritt erkannt um',
      customerLabel: 'Kunde:',
      entriesInWindow: 'Zutritte im Zeitfenster',
      anonymousPayments: 'Anonyme Zahlungen',
      windowDuration: 'Fensterdauer',
      minSuffix: 'Min.',
      // Alert detail — investigation guide
      activityTimeline: 'Aktivitätsverlauf',
      cctvGuide: 'CCTV-Untersuchungsanleitung',
      step1Title: 'Eintrittsvideo lokalisieren',
      step1Desc: 'CCTV-Aufnahme genau ab',
      step1End: 'am Eingang/Zugangsscanner prüfen.',
      step2PaymentsTitle: 'Anonyme Zahlungen im Zeitfenster',
      step2Desc: 'Verfolgen Sie den Kunden und prüfen Sie, ob er einer dieser Transaktionen am Kassensystem entspricht.',
      colTimeLocal: 'Uhrzeit (lokal)',
      colPaymentMethod: 'Zahlungsmethode',
      colItems: 'Artikel',
      step3Title: 'Ihr Urteil fällen',
      step3Desc: 'Zeigt die Kameraaufnahme, dass der Kunde Waren ohne Bezahlung mitnahm?',
      // Alert detail — review panel
      recordDetermination: 'Ihr Urteil festhalten',
      notesLabel: 'Notizen (optional)',
      notesPlaceholder: 'Beschreiben Sie, was Sie auf den CCTV-Aufnahmen beobachtet haben...',
      falseAlarmBtn: '✅ Fehlalarm',
      addToBlockedList: 'Zur Sperrliste hinzufügen',
      confirmedTheftBtn: '🚨 Bestätigter Diebstahl',
      reviewedOn: 'Geprüft am',
      reviewed: 'Geprüft.',
      alertDetail: 'Alarmdetails',
      legacyReadOnly: 'Alter Sentinel-v1-Alarm, aufbewahrt zur historischen Einsicht. Prüfaktionen sind deaktiviert.',
      // Timeline chart
      unknownItems: 'Unbekannte Artikel',
      entryEvent: 'Zutrittsereignis',
      paymentEvent: 'Zahlungsereignis',
      posPayment: 'Kassenzahlung',
      suspicionWindow: 'Verdachtszeitraum',
      noTimelineEvents: 'Keine Zutritts- oder Zahlungsereignisse in diesem Zeitfenster.',
      timelineWindowDesc: 'Zeitfenster: 10 Min. vor Zutritt → 20 Min. danach',
      timelineItem: 'Artikel',
      timelineEntry: 'Eintritt',
      timelineBounds: 'Zeitfenster:',
      closeDetails: 'Schliessen',
      timelineUnavailableEvents: 'Einige Ereignisse können in dieser Zeitleiste nicht angezeigt werden. Prüfen Sie die Details im Untersuchungsleitfaden.',
      timelineTimeUnavailable: 'Zeit nicht verfügbar',
      methodLabel: 'Methode:',
      amountLabel: 'Betrag:',
      itemsLabel: 'Artikel:',
      // Config form — PepperShop credentials
      pepperShopIntegration: 'PepperShop-Integration',
      pepperShopDesc: 'Gilt für alle Standorte Ihrer Organisation. Zugangsdaten werden verschlüsselt gespeichert.',
      syncFailing: '⚠️ Synchronisation schlägt derzeit fehl',
      baseUrl: 'Basis-URL',
      apiUsername: 'API-Benutzername',
      apiKey: 'API-Schlüssel',
      leaveBlankExisting: 'leer lassen, um vorhandenen zu behalten',
      enterApiKey: 'API-Schlüssel eingeben',
      hide: 'Verbergen',
      show: 'Anzeigen',
      saving: 'Speichern...',
      saveCredentials: 'Zugangsdaten speichern',
      testing: 'Wird geprüft...',
      testConnection: 'Verbindung testen',
      credentialsSaved: 'Zugangsdaten erfolgreich gespeichert.',
      connectionSuccess: 'Verbindung erfolgreich — PepperShop API ist erreichbar.',
      // Config form — store section
      configSaved: 'Konfiguration gespeichert.',
      testMessageSent: 'Testnachricht gesendet! Prüfen Sie Ihren Telegram-Kanal.',
      enabled: 'Aktiviert',
      disabled: 'Deaktiviert',
      botToken: 'Bot-Token',
      enterBotToken: 'Bot-Token von @BotFather eingeben',
      chatId: 'Chat-/Kanal-ID',
      windowMinutes: 'Zeitfenster (Minuten)',
      marginOfError: 'Fehlertoleranz',
      alertingEnabled: 'Tägliche Zusammenfassung aktiviert',
      muteWindowsLabel: 'Stummschaltungsfenster (Stoßzeiten)',
      addMuteWindow: '+ Hinzufügen',
      muteWindowsDesc: 'Alarme in Stoßzeiten unterdrücken, um Fehlalarme zu reduzieren.',
      noMuteWindows: 'Keine Stummschaltungsfenster konfiguriert.',
      muteWindowTo: 'bis',
      remove: 'Entfernen',
      save: 'Speichern',
      sending: 'Wird gesendet...',
      sendTestMessage: 'Testnachricht senden',
      locationAlertConfigs: 'Monitoring-Konfigurationen pro Standort',
      locationAlertConfigsDesc:
        'Alle Standorte unten prüfen, dann einen Standort öffnen für tägliche Zusammenfassungen, Erkennungsschwellen, Terminals und Ruhezeiten.',
      locationConfigSummaryFootnote:
        'Jede Zeile zeigt den aktuellen Entwurf dieses Standorts. Speichern gilt nur für diesen Standort.',
      locationConfigColAlerts: 'Zusammenfassung',
      locationConfigColWindow: 'Fenster',
      locationConfigColCount: 'Zählung',
      locationConfigColTelegram: 'Telegram',
      locationConfigColTerminals: 'Terminals',
      locationConfigConfigure: 'Bearbeiten',
      locationConfigColExpand: 'Aufklappen',
      locationConfigClose: 'Schließen',
      locationConfigSectionNotify: 'Benachrichtigungen',
      locationConfigSectionNotifyDesc: 'Tägliche Zusammenfassungen ein- oder ausschalten, Ziel festlegen und Bot-Token bei Bedarf erneuern.',
      locationConfigSectionDetect: 'Erkennung',
      locationConfigSectionTerminals: 'Zahlungen zuordnen',
      locationConfigQuietHoursToggle: 'Ruhezeiten (Stummschaltung)',
      locationConfigQuietHoursClosed: 'Optional — aufklappen für Stoßzeiten',
      locationConfigTelegramOk: 'Chat gesetzt',
      locationConfigTelegramMissing: 'Kein Chat',
      locationConfigTerminalsAllOrg: 'Gesamt org',
      locationConfigTerminalsCount: '{count} gewählt',
      locationConfigCountUniqueShort: 'Unique',
      locationConfigTerminalsCountShort: '{count}',
      // Day names for mute window dropdowns
      dayMonday: 'Montag',
      dayTuesday: 'Dienstag',
      dayWednesday: 'Mittwoch',
      dayThursday: 'Donnerstag',
      dayFriday: 'Freitag',
      daySaturday: 'Samstag',
      daySunday: 'Sonntag',
      // Unique customer count + count mode
      uniqueCustomers: 'Einzigartige Kunden',
      countMode: 'Zählmodus',
      countModeEntries: 'Gesamte Zutritte',
      countModeUniqueCustomers: 'Einzigartige Kunden',
      countModeDesc: 'Anonyme Zahlungen mit gesamten Zutritten oder einzigartigen Kunden im Zeitfenster vergleichen.',
      // Customer IDs modal
      windowCustomersTitle: 'Kunden im Zeitfenster',
      windowCustomersDesc: 'Alle einzigartigen Kunden-IDs aus dem Alarmzeitfenster',
      windowCustomersEmpty: 'Keine Kunden-IDs für dieses Zeitfenster verfügbar.',
      customerIdTooltip: 'Klicken, um alle Kunden in diesem Zeitfenster zu sehen',
      // Stats column format
      statUnique: 'einzigartig',
      statIn: 'ein',
      statPaid: 'bezahlt',
      // Timeline chart — payment type distinction
      anonPaymentEvent: 'Anonyme Zahlung',
      identifiedPaymentEvent: 'Identifizierte Zahlung',
      identifiedPaymentNote: 'Kunde hat bezahlt — wird nicht als anonym gezählt',
      posTerminalIds: 'Kassen-Terminal-IDs',
      posTerminalIdsDesc: 'Wählen Sie, welche PepperShop-Terminals zu diesem Standort gehören. Nur Zahlungen dieser Terminals zählen im Erkennungsfenster. Bei mehreren Kassenlanen alle IDs erfassen.',
      posTerminalIdsFetch: 'Aus PepperShop laden',
      posTerminalIdsFetching: 'Terminals werden geladen…',
      posTerminalIdsFetchError: 'Terminal-IDs konnten nicht aus PepperShop geladen werden. Bitte manuell eingeben.',
      posTerminalIdsFetchEmpty: 'Keine Terminals in den letzten 90 Tagen gefunden. Bitte manuell eingeben.',
      posTerminalIdsManualLabel: 'Terminal-ID manuell hinzufügen',
      posTerminalIdsManualPlaceholder: 'z. B. 3',
      posTerminalIdsManualAdd: 'Hinzufügen',
      posTerminalIdsSelected: 'Aktive Terminals',
      posTerminalIdsNone: 'Keine Terminals konfiguriert — alle Zahlungen der Organisation werden gezählt (nur bei einem einzigen Standort verwenden).',
      posTerminalIdsRemove: 'Terminal {id} entfernen',
      recap: {
        settingsTitle: 'Tagesbericht-Einstellungen',
        enableDailyRecap: 'Täglichen Bericht aktivieren',
        sendHour: 'Sendezeit',
        timezone: 'Zeitzone',
        sendToTelegram: 'Per Telegram senden',
        botToken: 'Bot-Token',
        botTokenConfiguredPlaceholder: 'Konfiguriert — leer lassen, um den bestehenden Token zu behalten',
        botTokenEnterPlaceholder: 'Bot-Token eingeben',
        chatId: 'Chat-ID',
        chatIdPlaceholder: 'z. B. -1001234567890',
        testTelegramButton: 'Testnachricht senden',
        testTelegramSending: 'Test wird gesendet…',
        testTelegramSuccess: 'Testnachricht gesendet. Prüfen Sie Ihren Telegram-Kanal.',
        testTelegramFailed: 'Test fehlgeschlagen.',
        saveButton: 'Speichern',
        saveButtonSaving: 'Wird gespeichert…',
        saveSuccess: 'Gespeichert.',
        saveFailed: 'Speichern fehlgeschlagen.',
        statusEnabled: 'Aktiv',
        statusDisabled: 'Inaktiv',
        collapseHint: 'Einstellungen einklappen',
        expandHint: 'Einstellungen ausklappen',
        telegramFailedBanner: '{count} aufeinanderfolgende Telegram-Benachrichtigung(en) fehlgeschlagen.',
        previewTitle: 'Heute',
        previewSubtitleLive: 'Live-Vorschau',
        previewSubtitleDaily: 'Tagesbericht',
        recomputeAria: 'Bericht neu berechnen',
        asOfLabel: 'Aktualisiert {time} ({timezone})',
        refreshAria: 'Vorschau aktualisieren',
        locationCountSingular: '1 Standort',
        locationCountPlural: '{count} Standorte',
        previewUnavailable: 'Vorschau nicht verfügbar.',
        coverageLabel: 'Zahlungsabdeckung',
        coverageHeroSummary: '{payments} Zahlungen für {unique} einzigartige Kunden mit Zutritt heute.',
        coveragePercent: '{pct} %',
        thresholdLegend: 'Schwellen: ≥ 70 % bezahlt vs. einzigartige Kunden → Normal. 40–70 % → Beobachten. Unter 40 % → Bedenklich.',
        metricEntries: 'Zutritte',
        metricUnique: 'Einzigartige Kunden',
        metricPayments: 'Zahlungen',
        metricCoverage: 'Abdeckung',
        vs7dBaseline: '{days}-Tages-Durchschnitt',
        noBaselineYet: 'Noch zu wenig Historie für einen Vergleich.',
        perLocationTitle: 'Aktivität pro Standort',
        colLocation: 'Standort',
        colEntries: 'Zutritte',
        colUnique: 'Einzigartige',
        colGranted: 'Gewährt',
        colDenied: 'Verweigert',
        colErrors: 'Fehler',
        colPayments: 'Zahlungen',
        paymentsUnattributedTooltip:
          'POS-Zahlungen erscheinen hier, wenn Sie die PepperShop-Kassen (Cashier-/Terminal-)IDs in den Sentinel-Einstellungen des Standorts verknüpfen. Die Gesamtzahl gilt weiterhin für die gesamte Organisation.',
        deniedAttentionTooltip: 'Dieser Standort hat heute verweigerte Zutritte — tippen zur Prüfung.',
        openLocationAria: 'Standort {name} öffnen',
        sortHint: 'Spaltenüberschrift anklicken zum Sortieren',
        evalNormal: 'Normal',
        evalWatch: 'Beobachten',
        evalConcerning: 'Bedenklich',
        last7DaysTitle: 'Letzte 7 Tage',
        noRecapsYet: 'Noch keine gespeicherten Berichte. Systemberichte werden jeden Morgen erzeugt.',
        telegramSentLabel: 'Via Telegram gesendet',
      },
      tabAlerts: 'Alarme',
      tabRecap: 'Tagesbericht',
      tabWeekReview: 'Wochenprüfung',
      tabLegacyAlerts: 'Alte Alarme',
      v2: {
        awaitingManager: "Geprüft — Manager-Entscheidung ausstehend.",
        reviseDecision: "Entscheidung ändern",
        previousWeek: "Vorherige Woche",
        nextWeek: "Nächste Woche",
        weekStarting: "Wochenbeginn",
        makeDecision: "Entscheidung treffen",
        saveNotes: "Notizen speichern",
        triageTitle: "Beobachtungen festhalten",
        triageGuidance: "Prüfen Sie Kameraaufnahmen, Zeiten und Zahlungsbelege. Ergänzen Sie Auffälligkeiten als Notizen für die Manager-Prüfung. Die Kundenidentifizierung und die endgültige Entscheidung übernimmt ein Manager.",
        triageOutcomeTitle: "Triage abschließen",
        triageOutcomeGuidance: "Schließen Sie einen Fehlalarm, wenn die Belege die Abweichung erklären, oder senden Sie Ihre Beobachtungen zur Manager-Entscheidung.",
        closeFalseAlarm: "Als Fehlalarm schließen",
        sendManagerReview: "Zur Manager-Prüfung senden",
        triaged: "Geprüft",
        awaitingManagerCount: "Manager-Entscheidung ausstehend",
        decisionResolved: "Entscheidung abgeschlossen",
        checklistDone: "Tagesprüfung abgeschlossen",

        reanalysisDisabled: 'Die Neuberechnung ist derzeit deaktiviert. Bestehende Berichte bleiben verfügbar.',
        reanalysisConflict: 'Die Vorschau ist nicht mehr gültig oder Berichte, Bewertungen oder Einstellungen haben sich geändert. Erstellen Sie eine neue Vorschau.',
        reanalysisPaused: 'Die Analyse ist pausiert. Setzen Sie die Analyse vor einer Neuberechnung fort.',
        reanalysisEnrollment: 'Die neue Analyse ist für diese Organisation noch nicht aktiviert. Aktivieren Sie sie vor einer Neuberechnung.',
        visitsPayments: '{entries} berechtigte Besuche · {payments} Zahlungen',
        shortfall: 'Nicht abgeglichene Besuche',
        reanalysisIntervalUnavailable: 'Berichtszeitraum nicht verfügbar. Neue Vorschau erstellen.',
        reportingInterval: 'Berichtszeitraum',
        incompleteEvidence: 'Unvollständige Belege — vor der Entscheidung Kameraaufnahmen und Zahlungsbelege prüfen.',
        deadlineReason: 'Die Startfrist wurde erreicht, während Aktivitäten an der Berichtsgrenze noch ungeklärt waren.',
        snapshotCaptured: 'Momentaufnahme erfasst',
        incomingEvidence: 'Ungeklärte Belege aus dem vorherigen Berichtszeitraum. Vorherigen Bericht prüfen oder einen Administrator um eine Vorschau der Neuanalyse bitten.',
        lastFinalizedReport: 'Letzter abgeschlossener Bericht',
        distinctCustomers: 'Unterschiedliche berechtigte Kunden',
        legacyCalendar: 'Frühere Kalendertagsberechnungen',
        legacyOperational: 'Frühere Betriebstagsberechnungen',
        finalizedPending: 'Abgeschlossener Bericht steht noch aus.',
        finalizedReport: 'Abgeschlossener Betriebsbericht',
        operationalReport: 'Betriebsbericht',
        incompleteReport: 'Unvollständige Belege — manuelle Prüfung erforderlich.',
        rawEntries: 'Rohe Zutrittsereignisse',
        grantedReport: 'Gewährt',
        deniedReport: 'Verweigert',
        errorsReport: 'Fehler',
        eligibleVisits: 'Berechtigte Besuche',
        periodPayments: 'Zahlungen im Berichtszeitraum',
        ownedAnomalies: 'Auffällige zugeordnete Zeitfenster',
        needsVerification: 'Manuelle Prüfung erforderlich',
        paymentsPerCustomer: 'Zahlungen je unterschiedlichem berechtigten Kunden',
        unavailableReport: 'nicht verfügbar',
        historicalReinterpretation: 'Historische Daten wurden mit der für diese Analyse genehmigten Konfiguration interpretiert.',
        supersededNotice: 'Diese Belege wurden ersetzt. Ursprüngliche Bewertung und Notizen bleiben erhalten; Änderungen sind nicht möglich.',
        openCurrentReport: 'Aktuellen Bericht öffnen',
        openReplacementWindow: 'Nachfolgendes Zeitfenster öffnen',
        reanalysisSelected: "Ausgewählte Berichtszeiträume",
        reanalysisUnavailable: "Nicht verfügbar",
        reanalysisFailed: "Neuberechnung fehlgeschlagen. Bestehende Berichte bleiben unverändert.",
        reanalysisRaw: "Rohe Zutritte",
        reanalysisVisits: "Berechtigte Besuche",
        reanalysisCustomers: "Verschiedene berechtigte Kunden",
        reanalysisPayments: "Zahlungen im Berichtszeitraum",
        reanalysisAnomalies: "Auffälligkeiten",
        reanalysisTitle: "Ausgewählte Zeiträume neu analysieren",
        reanalysisScope: "Inklusive Startdaten der Berichtszeiträume auswählen (05:00 bis 05:00 in der Berichtszeitzone). Die aktuelle Konfiguration wird verwendet; bestehende Bewertungen und Notizen bleiben erhalten.",
        reanalysisFrom: "Erster Berichtszeitraum",
        reanalysisTo: "Letzter Berichtszeitraum",
        reanalysisPreview: "Auswirkungen prüfen",
        reanalysisAffected: "Betroffene Berichte",
        reanalysisReviewed: "Bewertete Zeitfenster / Filialen",
        reanalysisRange: "Abhängiger Zeitraum",
        reanalysisEstimate: "Geschätzte API-Seiten",
        reanalysisExpires: "Vorschau läuft ab",
        reanalysisCompareOnly: "Zuerst vergleichen: Berichte bleiben bis zur Freigabe der Veröffentlichung unverändert.",
        reanalysisApprove: "Neuberechnung freigeben",
        reanalysisQueued: "Eingereiht; bestehende Berichte bleiben verfügbar.",
        reanalysisExpand: "Erforderlichen Zeitraum auswählen und erneut prüfen",
        reanalysisPeriod: "Berichtszeitraum",
        reanalysisMetric: "Kennzahl",
        reanalysisBefore: "Vorher",
        reanalysisAfter: "Nachher",
        reanalysisChangedReviews: "Geänderte bewertete Zeitfenster",
        reanalysisTheft: "Zu prüfende Diebstahlentscheidungen",
        reanalysisSent: "Bereits gesendete Telegram-Berichte bleiben unverändert",
        reanalysisActualPages: "Verwendete API-Seiten",
        reanalysisWindows: "Neue / entfernte / zusammengeführte Zeitfenster",
        reanalysisDownload: "Vergleich und Quellenzuordnungen herunterladen",
        reanalysisPublish: "Geprüften Vergleich veröffentlichen",
        historyFailed: "Berichtsverlauf konnte nicht geladen werden.",
        historyTitle: "Berichtsverlauf",
        historyEmpty: "Keine gespeicherten Versionen.",
        historyActive: "Aktiv",
        historyArchived: "Archiviert",
        historyMore: "Weitere Versionen laden",
        historyLegacy: "Alte Momentaufnahme: Nur ursprünglich gespeicherte Werte sind verfügbar.",
        historyLegacyEntries: "Gespeicherte eindeutige Zutritte",
        reanalysisState_previewed: "Vorschau bereit",
        reanalysisState_queued: "Eingereiht",
        reanalysisState_staged: "Vergleich bereit",
        reanalysisState_published: "Veröffentlicht",
        reanalysisState_failed: "Fehlgeschlagen; bestehende Berichte bleiben verfügbar.",
        reanalysisState_blocked: "Blockiert; bestehende Berichte bleiben verfügbar.",

        // Upgrade notice
        upgradeTitle: 'Sentinel nutzt jetzt tägliche Analysen.',
        upgradeBody:
          'Das Dashboard zeigt vorberechnete Erkennungsfenster für abgeschlossene Betriebstage. Live-v1-Polling und Einzelalarm-Rauschen sind nicht mehr Teil des normalen Prüfablaufs.',
        // Batch status banner
        batchMissingConfig: 'Die tägliche Analyse ist verfügbar, aber ein oder mehrere Standorte benötigen eine Terminal-Konfiguration.',
        batchCompleted: 'Tägliche Analyse abgeschlossen. Prüfen Sie unten die verdächtigen Zeitfenster.',
        batchRunning: 'Die tägliche Analyse wird vorbereitet.',
        batchFailed: 'Tägliche Analyse fehlgeschlagen. Admin-Prüfung erforderlich.',
        batchMissing: 'Für diesen Tag ist noch keine tägliche Analyse verfügbar.',
        batchNeverRan: 'Die tägliche Analyse ist noch nie gelaufen — Zahlungs- und Prüfdaten bleiben leer, bis der Batch läuft.',
        batchStale: 'Tägliche Analyse zuletzt abgeschlossen {age}. Zahlungsdaten sind möglicherweise veraltet — der tägliche Batch läuft eventuell nicht.',
        batchWaitingUntil: 'Warten bis {time} vor dem täglichen Zahlungsabgleich.',
        batchWaiting: 'Warten auf die nächste Bereitschaftsprüfung.',
        batchStartedLate: 'Diese Analyse wurde nach dem geplanten spätesten Start begonnen.',
        batchOverdue: 'Der geplante Start ist überfällig. Der Berichtszeitraum bleibt unverändert.',
        batchPreviousAvailable: 'Der bisherige abgeschlossene Bericht bleibt verfügbar, während dieser Versuch überprüft werden muss.',
        batchStaleHint: 'Zahlungsdaten stammen aus dem täglichen Abgleich. Prüfen Sie die geplante Analyse und danach die Vorschau für eine erneute Analyse ausgewählter Tage.',
        batchOperationalDay: 'Betriebstag: {date}',
        batchBasedOnNote: 'Die tägliche Prüfung basiert auf abgeschlossener Batch-Analyse, nicht auf Live-Polling.',
        runAnalysis: 'Analyse starten',
        runningAnalysis: 'Läuft…',
        retry: 'Erneut versuchen',
        ageLessThanHour: 'vor weniger als einer Stunde',
        ageHourOne: 'vor 1 Stunde',
        ageHours: 'vor {n} Stunden',
        ageDayOne: 'vor 1 Tag',
        ageDays: 'vor {n} Tagen',
        // Week view
        weekReview: 'Wochenprüfung',
        loadWeekFailed: 'Woche konnte nicht geladen werden',
        loadWindowsFailed: 'Erkennungsfenster konnten nicht geladen werden',
        loadWindowFailed: 'Erkennungsfenster konnte nicht geladen werden',
        loadingWindow: 'Erkennungsfenster wird geladen',
        windowNotFound: 'Erkennungsfenster nicht gefunden.',
        backToSentinel: 'Zurück zu Sentinel',
        reportTitle: 'Bericht zum Erkennungsfenster',
        openReport: 'Bericht öffnen',
        openReportNewTab: 'Bericht in neuem Tab öffnen',
        loadDayFailed: 'Erkennungsdaten konnten nicht geladen werden',
        retryBatchFailed: 'Batch konnte nicht erneut gestartet werden',
        reviewUpdateFailed: 'Prüfstatus konnte nicht aktualisiert werden. Bitte erneut versuchen.',
        anomaliesCount: '{count} Anomalien',
        entriesPayments: '{entries} Zutritte · {payments} Zahlungen',
        locationFallback: 'Standort',
        // Store day view
        backToWeek: 'Wochenansicht',
        storeDaySummary: '{entries} Zutritte · {payments} Zahlungen · {anomalies} verdächtige Zeitfenster',
        reviewedBadge: 'Tagesprüfung abgeschlossen',
        markReviewed: 'Tagesprüfung abschließen',
        colWindow: 'Zeitfenster',
        colEntries: 'Zutritte',
        colPayments: 'Zahlungen',
        colDuration: 'Dauer',
        colStatus: 'Status',
        noWindowsMatch: 'Keine Erkennungsfenster entsprechen dieser Ansicht.',
        pageLabel: 'Seite {page}',
        // Window detail
        backToWindows: 'Erkennungsfenster',
        detectionWindow: 'Erkennungsfenster',
        uniqueEntries: 'Eindeutige Zutritte',
        margin: 'Toleranz',
        selectCustomerFirst: 'Wählen Sie zuerst den per CCTV bestätigten Kunden aus, bevor Sie den Diebstahl erfassen.',
        reviewFailed: 'Prüfung konnte nicht gespeichert werden',
        blockPropagated: 'Kunde wurde auf die Sperrliste gesetzt. Geräte der Filiale aktualisiert am',
        blockPending: 'Kunde ist auf der Sperrliste, aber die Geräte der Filiale wurden noch nicht aktualisiert. Dies wird automatisch erneut versucht.',
        blockRetry: 'Geräte jetzt aktualisieren',
        blockRetrying: 'Geräte werden aktualisiert…',
        blockRetryFailed: 'Die Geräte der Filiale konnten nicht aktualisiert werden. Bitte später erneut versuchen.',
        notesSaveFailed: 'Notizen konnten nicht gespeichert werden',
        step1From: 'CCTV-Aufnahmen prüfen von',
        step1To: 'bis',
        step2Title: 'Anonyme Zahlungen in diesem Zeitfenster',
        step2Desc: 'Verfolgen Sie den Kunden auf der Kamera und prüfen Sie, ob er zu einer dieser POS-Transaktionen passt.',
        noAnonPayments: 'Keine anonymen Zahlungen in diesem Zeitfenster.',
        colTime: 'Zeit',
        colMethod: 'Methode',
        colPayment: 'Zahlung',
        windowStart: 'Fensterbeginn',
        entryReference: 'Eintritt {label} · {time}',
        noCustomerSelected: 'Kein Kunde ausgewählt',
        selectedCustomer: 'Ausgewählter Kunde',
        confirmedCustomer: 'Bestätigter Kunde',
        copyCustomerIdFailed: 'Kunden-ID konnte nicht kopiert werden.',
        step3Title: 'Kunden identifizieren',
        step3Desc: 'Wählen Sie den Kunden aus, den Sie auf der Aufnahme identifiziert haben.',
        noCustomerIds: 'Keine Kunden-IDs in diesem Zeitfenster.',
        copyCustomerId: 'Vollständige Kunden-ID kopieren',
        step4Title: 'Ihr Urteil fällen',
        step4Desc: 'Zeigt die Aufnahme, dass der Kunde den Laden mit unbezahlten Waren verlässt?',
        notesPlaceholder: 'Notizen — beschreiben Sie, was Sie auf den Aufnahmen beobachtet haben…',
        blockCustomerToggle: 'Ausgewählten Kunden zur Sperrliste hinzufügen',
        editNotes: 'Notizen bearbeiten',
        addNotesPlaceholder: 'Prüfnotizen hinzufügen…',
        dayBack: 'Zurück',
        dailyRecapHeading: 'Tagesbericht',
        noDailyRecap: 'Kein Tagesbericht für dieses Datum.',
        detectionWindowsHeading: 'Erkennungsfenster',
        noDetectionData: 'Keine Erkennungsdaten für dieses Datum.',
        reviewedDone: 'Erledigt',
      },
    },
    locations: {
      operatingHours: {
        title: 'Öffnungszeiten',
        descBefore: 'Legen Sie fest, wann dieser Standort in',
        descAfter: ' als geöffnet gilt. Whitelisted-Kunden können weiterhin außerhalb dieser Zeiten eintreten, der Standard-Zugang folgt jedoch diesem Zeitplan.',
        locationLocalTime: 'lokale Standortzeit',
        mode: 'Modus',
        mode247Title: 'Rund um die Uhr geöffnet',
        mode247Desc: 'Standort gilt immer als geöffnet. Am besten für 24/7-Standorte.',
        mode247Note: 'Standort wird zu jeder Zeit als geöffnet behandelt. Geeignet für 24/7-Standorte (z. B. Bars, Nachtgyms).',
        modeCustomTitle: 'Individuelle Wochenstunden',
        modeCustomDesc: 'Legen Sie für jeden Tag unterschiedliche Öffnungs- und Schließzeiten fest.',
        colDay: 'Tag',
        colStatus: 'Status',
        colOpen: 'Öffnung',
        colClose: 'Schließung',
        colEdit: 'Bearbeiten',
        dayOpen: 'Geöffnet',
        dayClosed: 'Den ganzen Tag geschlossen',
        markClosedLabel: 'Tag als geschlossen markieren',
        markOpenLabel: 'Tag als geöffnet markieren',
        editBtn: 'Bearbeiten',
        doneBtn: 'Fertig',
        saving: 'Wird gespeichert…',
        saveBtn: 'Öffnungszeiten speichern und an Gerät übertragen',
        noChanges: 'Keine Änderungen zum Speichern',
        updateFailed: 'Öffnungszeiten konnten nicht aktualisiert werden',
        updateSuccess: 'Öffnungszeiten aktualisiert. Geräte erhalten den neuen Zeitplan über die Konfigurationssynchronisation.',
        validationTimesRequired: 'Bitte Öffnungs- und Schließzeit für {day} eingeben.',
        validationTimeFormat: 'Zeiten müssen für {day} im Format HH:mm sein.',
        confirmTitle: 'Öffnungszeiten aktualisieren?',
        confirmDesc: 'Sie sind dabei, die Öffnungszeiten dieses Standorts zu aktualisieren und den neuen Zeitplan an das verbundene Gerät zu übertragen. Whitelist-Ausnahmen gelten weiterhin.',
        cancelBtn: 'Abbrechen',
        confirmBtn: 'Bestätigen und übertragen',
      },
    },
    commands: {
      updateBlocked: 'Remote-Update nicht verfügbar — dieses Gerät nutzt Edge-Software älter als v{min}',
      updateBlockedCurrentVersion: ' (aktuell v{version})',
      statusPending: 'Eingereiht',
      statusSent: 'Gesendet',
      pendingExpectation:
        'Läuft beim nächsten Geräte-Heartbeat (meist innerhalb einer Minute) — keine Aktion nötig.',
      sentExpectation:
        'Das Gerät hat den Befehl erhalten und arbeitet daran. Der Status aktualisiert sich automatisch.',
      sentUpdateExpectation:
        'Das Gerät hat den Befehl erhalten und installiert das Update — das kann einige Minuten dauern. Der Status aktualisiert sich automatisch.',
      delayedHint:
        'Dauert länger als üblich — das Gerät ist möglicherweise offline oder ausgelastet. Über den Aktualisieren-Button in der oberen Leiste den neuesten Status prüfen.',
      statusExecuted: 'Ausgeführt',
      statusFailed: 'Fehlgeschlagen',
      statusCancelled: 'Abgebrochen',
      diagStatusCompletedHealthy: 'Abgeschlossen · Gesund',
      diagStatusCompletedAttention: 'Abgeschlossen · Aufmerksamkeit nötig',
      diagStatusCompletedCritical: 'Abgeschlossen · Handlung erforderlich',
      diagStatusCompletedIncomplete: 'Abgeschlossen · Nicht vollständig geprüft',
      executionLog: 'Ausführungsprotokoll',
      executionLogVersionLabel: ' · Edge v{version}',
      copyLog: 'Protokoll kopieren',
      copied: 'Kopiert',
      logTruncated: 'Protokoll gekürzt — das Gerät hat mehr Ausgaben erzeugt, als gesendet werden konnten.',
      logTooLarge: 'Das Gerät hat ein Ausführungsprotokoll gesendet, das zu groß zum Speichern war.',
      logDropped: 'Das Gerät hat ein fehlerhaftes Ausführungsprotokoll gesendet — es konnte nicht gespeichert werden.',
      outputDropped: 'Ausgabe verworfen, um das Größenlimit einzuhalten',
      appliedVersionLabel: 'Angewendete Version: {version}',
      historyEmpty: 'An dieses Gerät wurden noch keine Befehle gesendet.',
      deviceLabel: 'Gerät: {name}',
      githubAccessHint:
        'GitHub-Zugangsdaten fehlen möglicherweise auf diesem Gerät. Führe setup_github_access.sh einmal per SSH aus und versuche das Update erneut.',
      githubAccessDocsLink: 'GitHub-Zugang-Dokumentation',
      diagOverallHealthy: 'Gesund',
      diagOverallAttention: 'Aufmerksamkeit nötig',
      diagOverallCritical: 'Handlung erforderlich',
      diagOverallIncomplete: 'Bericht unvollständig',
      diagCountsSummary: '{passed} Prüfungen bestanden · {attention} brauchen Aufmerksamkeit',
      diagCountsSummaryWithUnavailable:
        '{passed} Prüfungen bestanden · {attention} brauchen Aufmerksamkeit · {unavailable} nicht geprüft',
      diagCopyReport: 'Bericht kopieren',
      diagViewChecks: 'Alle Prüfungen anzeigen',
      diagHideChecks: 'Prüfungen ausblenden',
      diagNextStep: 'Nächster Schritt:',
      diagLegacyTitle: 'Bericht nicht verfügbar',
      diagLegacyBody:
        'Befehl abgeschlossen, aber diese Softwareversion hat keinen Diagnosebericht geliefert. Aktualisiere die Edge-Software, um Selbsttest-Ergebnisse zu erhalten.',
      diagDroppedTitle: 'Bericht nicht lesbar',
      diagDroppedBody:
        'Selbsttest abgeschlossen, aber das Format des Diagnoseberichts konnte nicht gelesen werden. Edge-Software aktualisieren oder Support kontaktieren, wenn das erneut passiert.',
      diagTruncatedTitle: 'Bericht zu groß',
      diagTruncatedBody:
        'Selbsttest abgeschlossen, aber das Gerät hat mehr Diagnosedetails gesendet, als gespeichert werden konnten. Edge-Software aktualisieren, wenn das erneut passiert.',
      diagUnavailableTitle: 'Nicht vollständig geprüft',
      diagCheckClock: 'Uhr / Zeitsync',
      diagCheckDisk: 'Festplattenspeicher',
      diagCheckMemory: 'Speicher',
      diagCheckConfig: 'Konfiguration',
      diagCheckUploadQueue: 'Upload-Warteschlange',
      diagCheckDeadLetters: 'Abgelehnte Logs',
      diagCheckRelay: 'Tür-Relais',
      diagCheckUnknown: 'Prüfung: {id}',
      diagReasonUnknown: 'Ergebniscode: {reason}',
      diagReason: {
        clock_ok: 'Systemuhr ist korrekt und synchronisiert.',
        clock_year_ok_sync_unknown:
          'Jahreszahl der Systemuhr sieht korrekt aus. Sync-Status konnte auf diesem Gerät nicht bestätigt werden.',
        clock_year_invalid:
          'Systemuhr ist falsch. TLS und Audit-Zeitstempel sind unzuverlässig.',
        clock_not_synchronized: 'Systemuhr ist nicht mit einem Zeitserver synchronisiert.',
        disk_ok: 'Festplattenspeicher ist in Ordnung ({pct}% belegt).',
        disk_low: 'Festplattenspeicher wird knapp ({pct}% belegt).',
        disk_critical: 'Festplattenspeicher ist kritisch niedrig ({pct}% belegt).',
        disk_stat_unavailable: 'Festplattennutzung konnte auf diesem Gerät nicht gemessen werden.',
        memory_ok: 'Verfügbarer Speicher ist in Ordnung ({mb} MB frei).',
        memory_low: 'Verfügbarer Speicher ist niedrig ({mb} MB frei).',
        memory_critical: 'Verfügbarer Speicher ist kritisch niedrig ({mb} MB frei).',
        memory_stat_unavailable: 'Speichernutzung konnte auf diesem Gerät nicht gemessen werden.',
        config_ok: 'Laufzeitkonfiguration ist lesbar.',
        config_missing: 'Laufzeitkonfiguration fehlt oder ist nicht lesbar.',
        config_cloud_missing: 'Cloud-Konfigurationsabschnitt fehlt.',
        config_heartbeat_missing: 'Heartbeat-Intervall ist in der Konfiguration nicht gesetzt.',
        upload_queue_ok: 'Upload-Warteschlange ist in Ordnung ({count} ausstehend).',
        upload_queue_stalled:
          '{count} Zutrittslogs warten auf Upload und scheinen festzustecken.',
        upload_queue_unavailable: 'Upload-Warteschlangen-Datenbank konnte nicht geöffnet werden.',
        dead_letters_ok: 'Keine dauerhaft abgelehnten Logs auf dem Gerät gespeichert.',
        dead_letters_present:
          '{count} Logs wurden dauerhaft abgelehnt und müssen geprüft werden.',
        dead_letters_unavailable: 'Speicher für abgelehnte Logs konnte nicht geprüft werden.',
        relay_connected: 'Tür-Relais-Hardware ist verbunden.',
        relay_disconnected: 'Tür-Relais-Hardware wurde nicht erkannt.',
        relay_mock_mode:
          'Relais-Prüfung übersprungen — dieses Gerät läuft ohne USB-Hardware (Entwicklungs-/Mock-Modus).',
        relay_probe_unavailable: 'Relais-Prüfung war in diesem Lauf nicht verfügbar.',
        relay_probe_failed: 'Relais-Prüfung ist unerwartet fehlgeschlagen.',
        check_crashed: 'Diese Prüfung ist abgestürzt und konnte nicht abgeschlossen werden.',
      },
      diagAction: {
        clock_year_invalid:
          'Netzwerkzugang für Zeitsync (NTP) prüfen, dann das Gerät neu starten.',
        clock_not_synchronized:
          'Prüfen, ob das Ladennetzwerk NTP erlaubt, bei Bedarf neu starten.',
        disk_low:
          'Support bitten, Speicherplatz freizugeben, bevor es kritisch wird.',
        disk_critical:
          'Sofort Support kontaktieren — das Gerät könnte aufhören zu loggen oder zu aktualisieren.',
        memory_low: 'Gerät neu starten, wenn es langsam oder nicht erreichbar wird.',
        memory_critical:
          'Gerät jetzt neu starten. Support kontaktieren, wenn das wiederholt passiert.',
        config_missing:
          'Support kontaktieren — die Konfiguration muss möglicherweise wiederhergestellt werden.',
        config_cloud_missing:
          'Support kontaktieren — Cloud-Sync-Einstellungen könnten unvollständig sein.',
        config_heartbeat_missing:
          'Config-Update vom Dashboard senden oder Support kontaktieren.',
        upload_queue_stalled:
          'Internet im Laden prüfen. Wenn das Gerät Online ist, Neustart versuchen; Support kontaktieren, wenn der Rückstand bleibt.',
        upload_queue_unavailable:
          'Support kontaktieren — lokaler Log-Speicher könnte beschädigt sein.',
        dead_letters_present:
          'Support kontaktieren, um Dead-Letter-Logs auf dem Gerät zu prüfen.',
        relay_disconnected:
          'USB-Relais-Kabel im Laden prüfen. Support kontaktieren, wenn es eingesteckt ist.',
        relay_probe_failed:
          'Support kontaktieren — die USB/HID-Schicht braucht möglicherweise Aufmerksamkeit.',
        check_crashed:
          'Selbsttest erneut ausführen. Support kontaktieren, wenn er weiter fehlschlägt.',
      },
      // Remote command panel
      panelTitle: 'Remote-Befehle',
      panelDesc: 'Remote-Aktionen auf diesem Gerät auslösen. Befehle werden beim nächsten Heartbeat zugestellt.',
      restartDevice: 'Gerät neu starten',
      runDiagnostics: 'Diagnose ausführen',
      enqueuing: 'Wird eingereiht…',
      enqueueSuccess: 'Befehl {command} erfolgreich eingereiht.',
      updateConfigNote: 'Hinweis: UPDATE_CONFIG-Befehle werden beim Speichern von Konfigurationsänderungen automatisch eingereiht.',
      // Command history table
      historyNoCommands: 'Keine Befehle gefunden.',
      historyColCreated: 'Erstellt',
      historyColCommand: 'Befehl',
      historyColStatus: 'Status',
      historyColSent: 'Gesendet',
      historyColExecuted: 'Ausgeführt',
      historyColError: 'Fehler',
      statusAcked: 'Bestätigt',
    },
    maintenance: {
      edgeVersion: 'Edge v{version}',
      edgeVersionUnknown: 'Edge-Version unbekannt',
      heartbeatHint: 'Befehle werden beim nächsten Geräte-Heartbeat ausgeführt.',
      journeyLabel: 'Wartungsablauf',
      journeyDiagnoseTitle: '1. Diagnostizieren',
      journeyDiagnoseBody:
        'Zuerst den Selbsttest starten, um Geräteprobleme von Netzwerk- oder Setup-Problemen zu trennen.',
      journeyInterveneTitle: '2. Eingreifen',
      journeyInterveneBody:
        'Neustart oder Software-Update nur nutzen, wenn das Ergebnis auf diese Aktion hinweist.',
      journeyVerifyTitle: '3. Prüfen',
      journeyVerifyBody:
        'Ergebnis in der Befehlshistorie prüfen, danach nach Änderungen erneut den Selbsttest starten.',
      enqueueFailed: 'Befehl konnte nicht in die Warteschlange gestellt werden',
      unknownError: 'Unbekannter Fehler',
      queueing: 'Wird eingereiht…',
      sendAgain: 'Erneut senden',
      cancel: 'Abbrechen',
      diagnosticsTitle: 'Diagnose',
      diagnosticsDesc:
        'Führt einen Remote-Selbsttest auf dem Gerät aus. Ergebnisse erscheinen unten in der Befehlshistorie. Startet nicht neu und ändert keine Software.',
      runSelfTest: 'Selbsttest starten',
      diagnosticsQueued: 'Selbsttest eingereiht — läuft beim nächsten Heartbeat-Zyklus.',
      deviceControlTitle: 'Gerätesteuerung',
      rebootDesc: 'Startet den Edge-Controller neu. Die Tür ist kurz offline, bis das Gerät wieder bereit ist.',
      rebootWhenTitle: 'Wann ein Neustart hilft',
      rebootWhen1: 'Der Türscanner liest keine QR-Codes mehr, obwohl das Gerät als Online angezeigt wird.',
      rebootWhen2: 'Das Gerät wird als Online angezeigt, reagiert aber nicht mehr auf aktuelle Befehle.',
      rebootWhen3: 'Internet oder Router im Laden wurden geändert und das Gerät hat sich nicht von selbst neu verbunden.',
      rebootBeforeTitle: 'Vor dem Neustart',
      rebootBefore1: 'Zuerst den Selbsttest oben ausführen — er findet das Problem oft, ohne die Tür offline zu nehmen.',
      rebootBefore2: 'Wird das Gerät als Offline angezeigt, erreicht ein Remote-Neustart es nicht. Stattdessen Strom und Internet im Laden prüfen.',
      rebootBefore3: 'Wenn alles funktioniert, sind routinemäßige Neustarts nicht nötig.',
      rebootDevice: 'Gerät neu starten',
      rebootConfirmPrompt: 'Zum Bestätigen den Standortnamen „{name}“ oder „RESTART“ eingeben:',
      typeToConfirm: 'Zur Bestätigung eingeben…',
      confirmRestart: 'Neustart bestätigen',
      restartQueued: 'Neustart eingereiht — das Gerät startet beim nächsten Heartbeat-Zyklus neu.',
      updateTitle: 'Edge-Software-Update',
      updateDesc:
        'Weist diesem Gerät ein Release-Ziel zu. Die Edge wendet es beim nächsten Heartbeat per Git an und startet kurz neu.',
      currentVersion: 'Aktuelle Version: v{version}',
      recommendedVersion: 'Neuestes Release: v{version}',
      recommendedDetecting: 'Neuestes Release-Tag wird ermittelt…',
      recommendedUnavailable: 'Neuestes Release-Tag konnte nicht ermittelt werden',
      updateTargetUnset: '(Release-Ziel festlegen)',
      updateSoftware: 'Edge-Software aktualisieren',
      upToDateBadge: 'Aktuell',
      upToDateHint: 'Dieses Gerät läuft mit dem neuesten Release (v{version}). Kein Update nötig.',
      updateAvailableBadge: 'Update verfügbar: v{version}',
      updateAnyway: 'Neu installieren oder anderes Ziel wählen',
      updateConfirmTitle: 'Software-Update bestätigen',
      updateGithubPrereq:
        'Git-v1-OTA braucht GitHub-Lesezugriff auf dem Gerät (einmalig per SSH eingerichtet). Zugangsdaten bleiben auf dem Gerät — nie in dieser Anfrage.',
      updateGithubDocsLink: 'GitHub-Zugang-Einrichtung öffnen',
      updateGithubCheckbox: 'Dieses Gerät hat GitHub-Zugang konfiguriert',
      updateTargetLabel: 'Release-Ziel',
      updateAdvancedReveal: 'Unveröffentlichtes Build nötig?',
      updateAdvancedWarningTitle: 'Nicht empfohlen für Produktion',
      updateAdvancedWarningBody:
        'origin/main folgt unveröffentlichten Commits ohne Release-Tag. Bevorzuge ein Release-Tag, außer du testest einen Fix, der noch nicht ausgeliefert wurde.',
      updateTrackLatest: 'Verstanden — origin/main (latest) folgen',
      updateAdvancedHide: 'Stattdessen Release-Tag verwenden',
      updateConsequenceTarget: 'Das Gerät checkt {target} aus und startet den Edge-Dienst neu.',
      updateConsequenceOffline: 'Der Zutritt kann während des Neustarts kurz nicht verfügbar sein.',
      updateConsequenceHeartbeat: 'Der Befehl wird beim nächsten Heartbeat zugestellt — nicht sofort.',
      updatePayloadSummary: 'Warteschlangen-Payload: target_version={target}',
      updateTargetLatestSummary: 'origin/main (latest)',
      confirmUpdate: 'Update bestätigen',
      updateQueued: 'Update eingereiht — das Gerät wendet es beim nächsten Heartbeat-Zyklus an.',
      qrSyncTitle: 'Bytekey-QR-Sync',
      qrSyncDesc: 'Capability und Snapshot-Status aus dem Edge-Heartbeat.',
      qrSyncReady: 'Bereit',
      qrSyncNotReady: 'Nicht bereit',
      qrSyncCapability: 'Capability',
      qrSyncStatus: 'Status',
      qrSyncSnapshotAge: 'Snapshot-Alter',
      qrSyncValidUntil: 'Gültig bis',
      qrSyncMissing: 'fehlt',
      qrSyncUnknown: 'unbekannt',
      qrSyncAgeUnknown: 'unbekannt',
      qrSyncAgeSeconds: '{seconds}s',
      qrSyncAgeMinutes: '{minutes}m',
      qrSyncAgeHours: '{hours}h',
      qrSyncAgeDays: '{days}d',
      qrSyncGateReason: 'Rollout-Gate: {reason}',
      qrSyncLastError: 'Letzter Fehler',
      historyTitle: 'Befehlshistorie',
      historyDesc: 'Nachweis der an dieses Gerät gesendeten Befehle und ihrer Ergebnisse.',
    },
    errors: {
      createOrganizationFailed: 'Organisation konnte nicht erstellt werden',
    },
  },
} as const

function getByPath(obj: unknown, path: string): string | undefined {
  const segments = path.split('.')
  let current: unknown = obj
  for (const segment of segments) {
    if (!current || typeof current !== 'object' || !(segment in (current as Record<string, unknown>))) {
      return undefined
    }
    current = (current as Record<string, unknown>)[segment]
  }
  return typeof current === 'string' ? current : undefined
}

export function t(locale: Locale, key: string, fallback?: string): string {
  return getByPath(messages[locale], key) ?? getByPath(messages.en, key) ?? fallback ?? key
}
